/*
 * theme-core.js — SafePro Custom theme core (readable build)
 * Generated 2026-10-14 from the former obfuscated core script. All string-table lookups inlined,
 * licence phone-home removed, identifiers renamed by scope-aware heuristics.
 * Loaded with defer from layout/*.liquid; secondary.js and theme sections depend on the custom elements below.
 *
 * Custom element classes: CartRemoveButton, CartItems, SearchForm, PredictiveSearch, CartDrawer, CartDrawerItems, QuantityInput, InternalVideo, ComparisonSlider, PromoPopup, SectionsGroup, ClickableDiscount, DynamicDates, StickyAtc, BundleDeals, QuantityBreaks, SpxSubscriptionWidget, QuantityGifts, QuantityBreakUpsells, ProductInfoUpsell, CartDrawerUpsell, CartDrawerGift, MainBundleOffer, CustomProductField, VariantSelects, SecondaryVariantSelect, SecondaryVariantSelectSeparate, CardVariantSelects
 * Top-level helpers: subscribe, publish, initGiftsCheck, updateGiftStyles, checkGifts, validateSingleQuantityCartItems, validateCartGifts, removeLocalStorageGift, handleDiscountForm, handleDiscountFormChange, fixParsedHtml, serializePropValue, getFocusableElements, trapFocus, pauseAllMedia, removeTrapFocus, onKeyUpEscape, debounce, fetchConfig, addDays, formatDates, checkDateValidity, popupTimer, _qbGetPresentmentRate, updatePdpPrices, metafieldPoly, updateVariantStatuses, findAvailableVariant, updateGiftGoalInStorage, displayPrices, initTrapFocus, formatMoney, initToggleUpsells, playMedia
 */
const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    "cartUpdate": "cart-update",
    "quantityUpdate": "quantity-update",
    "optionValueSelectionChange": "option-value-selection-change",
    "variantChange": "variant-change",
    "cartError": "cart-error"
  },
  POST_LINK_INT = "xml_eval";
let subscribers = {};

function subscribe(event, event2) {
  return subscribers[event] === undefined && (subscribers[event] = []), subscribers[event] = [...subscribers[event], event2],
    function unsubscribe() {
      subscribers[event] = subscribers[event].filter(subscriber => {
        return subscriber !== event2;
      });
    };
};

function publish(eventName, data) {
  subscribers[eventName] && subscribers[eventName].forEach(subscriber => {
    subscriber(data);
  });
}
const GIFTS_LOCAL_STORAGE_KEY = "spx_gift_goals";
let shouldCheckGifts = false,
  giftsToMonitor = [];

function initGiftsCheck(fromCartPage = false) {
  let cartDrawerItems = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (fromCartPage) cartDrawerItems = document.querySelector("cart-items");
  if (!cartDrawerItems || cartDrawerItems.dataset.giftsStorage !== "true") return;
  const stored = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (!stored) return;
  const data = JSON.parse(stored);
  if (!data || typeof data !== "object") return;
  Object.values(data).forEach(gift => {
    const cartItemProduct = cartDrawerItems.querySelector(".cart-item--product-" + gift.gift_handle);
    if (!cartItemProduct) return;
    const giftProduct = document.querySelector(".gift--product-" + gift.gift_handle);
    if (giftProduct) return;
    shouldCheckGifts = true, giftsToMonitor.push(gift);
  }), updateGiftStyles(), checkGifts(fromCartPage);
}

function updateGiftStyles() {
  let spxGiftsStyle = document.getElementById("spx-gifts-style");
  if (spxGiftsStyle) spxGiftsStyle.remove();
  if (!giftsToMonitor.length) return;
  const styleEl = document.createElement("style");
  styleEl.id = "spx-gifts-style";
  const hideQuantityCss = giftsToMonitor.map(gift => ".cart-item--product-" + gift.gift_handle + " .quantity { display: none !important; }").join("\n");
  styleEl.textContent = hideQuantityCss, document.head.appendChild(styleEl);
}

function checkGifts(fromCartPage = false) {
  let cartDrawerItems = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (fromCartPage) cartDrawerItems = document.querySelector("cart-items");
  if (!shouldCheckGifts || !cartDrawerItems || !cartDrawerItems.updateQuantity) return;
  for (const giftsToMonitorVar of giftsToMonitor) {
    const cartItemProduct = cartDrawerItems.querySelector(".cart-item--product-" + giftsToMonitorVar.gift_handle);
    if (!cartItemProduct) {
      const giftIndex = giftsToMonitor.findIndex(gift => gift.gift_handle === giftsToMonitorVar.gift_handle);
      if (giftIndex > -1) giftsToMonitor.splice(giftIndex, 1);
      removeLocalStorageGift(giftsToMonitorVar);
      continue;
    }
    let shouldRemoveGift = false;
    if (giftsToMonitorVar.type === "product_quantity") {
      let unlockQuantity = 0;
      cartDrawerItems.querySelectorAll(".cart-item--product-" + giftsToMonitorVar.unlock_product_handle).forEach(unlockCartItem => {
        unlockQuantity += parseInt(unlockCartItem.dataset.quantity);
      });
      if (unlockQuantity < parseInt(giftsToMonitorVar.required_quantity)) shouldRemoveGift = true;
    } else {
      if (giftsToMonitorVar.type === "product_variant") {
        const cartItemProductList = cartDrawerItems.querySelectorAll(".cart-item--product-" + giftsToMonitorVar.unlock_product_handle);
        if (!cartItemProductList.length) shouldRemoveGift = true;
        else {
          const isArrayResult = Array.isArray(giftsToMonitorVar.valid_variants) ? giftsToMonitorVar.valid_variants : [];
          let variantMatches = false,
            hasVariantRequirement = false;
          cartItemProductList.forEach(cartItemProduct2 => {
            const variantOptions = cartItemProduct2.dataset.variantOptions;
            if (variantOptions) {
              hasVariantRequirement = true;
              const parts = variantOptions.split("|||").map(option => option.trim().toLowerCase());
              parts.some(part => isArrayResult.includes(part)) && (variantMatches = true);
            }
          });
          if (hasVariantRequirement && !variantMatches) shouldRemoveGift = true;
        }
      } else {
        const cartSubtotal = parseInt(cartDrawerItems.dataset.subtotal);
        if (cartSubtotal < parseInt(giftsToMonitorVar.required_quantity)) shouldRemoveGift = true;
      }
    }
    if (shouldRemoveGift) {
      const giftIndex = giftsToMonitor.findIndex(gift => gift.gift_handle === giftsToMonitorVar.gift_handle);
      if (giftIndex > -1) giftsToMonitor.splice(giftIndex, 1);
      removeLocalStorageGift(giftsToMonitorVar);
      const lineIndex = cartItemProduct.dataset.index ?? cartItemProduct.id.replace("CartItem-", "");
      cartDrawerItems.updateQuantity(lineIndex, 0);
      return;
    }
  }
}

function validateSingleQuantityCartItems(cartItemsEl, selectedGiftsByHandle) {
  for (const [giftHandle, giftVariantId] of Object.entries(selectedGiftsByHandle)) {
    const cartItemProductList = cartItemsEl.querySelectorAll(".cart-item--product-" + giftHandle);
    if (cartItemProductList.length === 0) continue;
    if (cartItemProductList.length > 1) {
      let keptItem = null,
        duplicateItems = [];
      cartItemProductList.forEach(cartItemProduct => {
        const dataQuantityVariantId = cartItemProduct.querySelector("[data-quantity-variant-id]"),
          quantityVariantId = dataQuantityVariantId ? dataQuantityVariantId.dataset.quantityVariantId : null;
        quantityVariantId === giftVariantId && !keptItem ? keptItem = cartItemProduct : duplicateItems.push(cartItemProduct);
      });
      !keptItem && duplicateItems.length > 0 && (keptItem = duplicateItems.shift());
      if (duplicateItems.length > 0) {
        const firstDuplicate = duplicateItems[0],
          lineIndex = firstDuplicate.dataset.index ?? firstDuplicate.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
        return cartItemsEl.updateQuantity(lineIndex, 0), true;
      }
    }
    if (cartItemProductList.length === 1) {
      const onlyItem = cartItemProductList[0],
        quantity = parseInt(onlyItem.dataset.quantity) || 1;
      if (quantity > 1) {
        const lineIndex = onlyItem.dataset.index ?? onlyItem.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
        return cartItemsEl.updateQuantity(lineIndex, 1), true;
      }
    }
  }
  returnfalse;
}

function validateCartGifts(isCartPage = false) {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;
  let cartDrawerItems = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (isCartPage) cartDrawerItems = document.querySelector("cart-items");
  if (!cartDrawerItems || !cartDrawerItems.updateQuantity) return;
  const cartDrawerGiftList = cartDrawer.querySelectorAll("cart-drawer-gift"),
    cartDrawerUpsellDataToggleList = cartDrawer.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"]");
  if (!cartDrawerGiftList.length && !cartDrawerUpsellDataToggleList.length) return;
  const drawerGiftsByHandle = {};
  cartDrawerGiftList.forEach(cartDrawerGift => {
    cartDrawerGift.dataset.handle && cartDrawerGift.dataset.id && cartDrawerGift.dataset.selected === "true" && (drawerGiftsByHandle[cartDrawerGift.dataset.handle] = cartDrawerGift.dataset.id);
  });
  const quantityGiftsByHandle = {};
  cartDrawerUpsellDataToggleList.forEach(cartDrawerUpsellDataToggle => {
    cartDrawerUpsellDataToggle.dataset.handle && cartDrawerUpsellDataToggle.dataset.id && cartDrawerUpsellDataToggle.dataset.selected === "true" && (quantityGiftsByHandle[cartDrawerUpsellDataToggle.dataset.handle] = cartDrawerUpsellDataToggle.dataset.id);
  });
  if (validateSingleQuantityCartItems(cartDrawerItems, drawerGiftsByHandle)) return;
  if (validateSingleQuantityCartItems(cartDrawerItems, quantityGiftsByHandle)) return;
}

function removeLocalStorageGift(gift) {
  const stored = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (stored) try {
    const data = JSON.parse(stored);
    data && data[gift.gift_handle] && (delete data[gift.gift_handle], localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(data)));
  } catch (error) {
    console.warn("Error parsing gift localStorage data:", error);
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", event => {
      event.preventDefault();
      if (this.dataset.handle) {
        const dataset = this.dataset.handle,
          quantityBreakUpsellDataHandleList = document.querySelectorAll(".quantity-break__upsell[data-handle=\"" + dataset + "\"]");
        quantityBreakUpsellDataHandleList.forEach(quantityBreakUpsellDataHandle => {
          quantityBreakUpsellDataHandle.dataset.selected = "false", quantityBreakUpsellDataHandle.classList.remove("quantity-break__upsell--selected");
          const inputType = quantityBreakUpsellDataHandle.querySelector("input[type=\"checkbox\"]");
          if (inputType) inputType.checked = false;
        });
      }
      const cartItemsEl = this.closest("cart-items") || this.closest("cart-drawer-items");
      this.clearCart ? cartItemsEl.clearCart() : cartItemsEl.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
var date = "2027-10-10";
class CartItems extends HTMLElement {
  constructor() {
    super(), this.lineItemContainer = formatDates(currentDate, date), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus"), this.secondCartItems = document.querySelector("cart-drawer-items"), this.quantityGifts = document.querySelector(".quantity-gifts");
    const debounceResult = debounce(event => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", debounceResult.bind(this)), this.isCartPage = this.nodeName === "CART-ITEMS", this.otherCartItemsSelector = this.isCartPage ? "cart-drawer-items" : "cart-items", this.hasOtherCartItems = document.querySelector(this.otherCartItemsSelector) !== null;
    if (this.hasOtherCartItems) {
      if (this.isCartPage) initGiftsCheck(true);
    } else initGiftsCheck(false);
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source === "cart-items") return;
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(response => response.text()).then(html => {
      const parsedDoc = new DOMParser().parseFromString(html, "text/html"),
        cartItems = parsedDoc.querySelector("cart-items");
      this.innerHTML = cartItems.innerHTML;
    }).catch(error => {
      console.error(error);
    });
  }
  updateCart() {
    const json = JSON.stringify({
      "sections": this.getSectionsToRender().map(section => section.section),
      "sections_url": window.location.pathname
    });
    fetch("/cart/update.js", {
      "method": "POST",
      "headers": {
        "Content-Type": "application/json"
      },
      "body": json
    }).then(response => response.json()).then(response2 => {
      this.classList.toggle("is-empty", response2.item_count === 0), this.getSectionsToRender().forEach(section => {
        const elementById = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementById.innerHTML = this.getSectionInnerHTML(response2.sections[section.section], section.selector);
      });
    }).catch(error => {
      console.error(error);
    });
  }
  getSectionsToRender() {
    return [{
      "id": "main-cart-items",
      "section": document.getElementById("main-cart-items").dataset.id,
      "selector": ".js-contents"
    }, {
      "id": "cart-icon-bubble",
      "section": "cart-icon-bubble",
      "selector": ".shopify-section"
    }, {
      "id": "cart-live-region-text",
      "section": "cart-live-region-text",
      "selector": ".shopify-section"
    }, {
      "id": "main-cart-footer",
      "section": document.getElementById("main-cart-footer").dataset.id,
      "selector": ".js-contents"
    }];
  }
  async updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const cartErrors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (cartErrors) cartErrors.textContent = "";
    const json = JSON.stringify({
      "line": line,
      "quantity": quantity,
      "sections": this.getSectionsToRender().map(section => section.section),
      "sections_url": window.location.pathname
    });
    try {
      const response = await fetch("" + routes.cart_change_url, {
          ...fetchConfig(),
          ...{
            "body": json
          }
        }),
        responseText = await response.text(),
        data = JSON.parse(responseText),
        quantity2 = document.getElementById("Quantity-" + line) || document.getElementById("Drawer-quantity-" + line),
        cartItemList = document.querySelectorAll(".cart-item");
      if (data.errors) {
        quantity2.value = quantity2.getAttribute("value"), this.updateLiveRegions(line, data.errors);
        return;
      }
      if (!data.sections) {
        const response2 = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(section => section.section).join(","));
        data.sections = await response2.json();
      }
      this.classList.toggle("is-empty", data.item_count === 0);
      const cartDrawer = document.querySelector("cart-drawer"),
        mainCartFooter = document.getElementById("main-cart-footer");
      if (mainCartFooter) mainCartFooter.classList.toggle("is-empty", data.item_count === 0);
      if (cartDrawer) cartDrawer.classList.toggle("is-empty", data.item_count === 0);
      this.getSectionsToRender().forEach(section => {
        const elementById = document.getElementById(section.id);
        if (elementById) {
          const sectionEl = elementById.querySelector(section.selector) || elementById;
          sectionEl.innerHTML = this.getSectionInnerHTML(data.sections[section.section], section.selector);
          const cartDrawerBody = sectionEl.querySelector(".cart-drawer__body");
          if (cartDrawerBody && this.cartDrawer) cartDrawerBody.scrollTop = this.cartDrawer.cartBodyScroll;
        }
      });
      const items = data.items[line - 1] ? data.items[line - 1].quantity : undefined;
      let errorMessage = "";
      cartItemList.length === data.items.length && items !== parseInt(quantity2.value) && (typeof items === "undefined" ? errorMessage = window.cartStrings.error : errorMessage = window.cartStrings.quantityError.replace("[quantity]", items));
      this.updateLiveRegions(line, errorMessage);
      const cartItem = document.getElementById("CartItem-" + line) || document.getElementById("CartDrawer-Item-" + line);
      if (cartItem && cartItem.querySelector("[name=\"" + name + "\"]")) cartDrawer ? trapFocus(cartDrawer, cartItem.querySelector("[name=\"" + name + "\"]")) : cartItem.querySelector("[name=\"" + name + "\"]").focus();
      else {
        if (data.item_count === 0 && cartDrawer) trapFocus(cartDrawer.querySelector(".drawer__inner-empty"), cartDrawer.querySelector("a"));
        else document.querySelector(".cart-item") && cartDrawer && trapFocus(cartDrawer, document.querySelector(".cart-item__name"));
      }
      if (cartDrawer) {
        cartDrawer.checkForClear();
        const countdownTimer = cartDrawer.querySelector("countdown-timer");
        if (countdownTimer) countdownTimer.playTimer();
        let giftUpdated = false;
        if (cartDrawer.querySelector("cart-drawer-gift")) {
          cartDrawer.checkForClear();
          let giftsToAdd = [],
            giftsToRemove = [];
          cartDrawer.querySelectorAll("cart-drawer-gift").forEach(giftEl => {
            giftEl.getUpdateRequired() && (cartDrawer.querySelector(".cart-item--product-" + giftEl.dataset.handle) ? giftEl.dataset.selected === "false" && giftsToRemove.push(giftEl) : giftEl.dataset.selected === "true" && giftsToAdd.push(giftEl));
          });
          if (giftsToRemove.length > 0) giftUpdated = true, giftsToRemove[0].removeFromCart();
          else giftsToAdd.length > 0 && (giftUpdated = true, giftsToAdd[0].addToCart());
        }
        this.quantityGifts && !giftUpdated && this.quantityGifts.initUnlock();
        const quantityBreakUpsellsList = document.querySelectorAll("quantity-break-upsells");
        quantityBreakUpsellsList.forEach(quantityBreakUpsell => {
          if (!giftUpdated) quantityBreakUpsell.initUnlock();
        });
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        "source": "cart-items",
        "cartData": data
      });
    } catch (error) {
      console.log(error), this.querySelectorAll(".loading-overlay").forEach(overlay => overlay.classList.add("hidden"));
      const cartErrors2 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      cartErrors2.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
      if (this.secondCartItems && this.secondCartItems.updateCart) this.secondCartItems.updateCart();
      const event = new CustomEvent("cartQuantityUpdated", {
        "detail": {
          "handle": "handle"
        }
      });
      document.dispatchEvent(event);
      if (shouldCheckGifts) checkGifts(this.isCartPage);
      validateCartGifts(this.isCartPage);
    }
  }
  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById("Line-item-error-" + line) || document.getElementById("CartDrawer-LineItemError-" + line);
    if (lineItemError) lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const cartLiveRegionText = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    cartLiveRegionText.setAttribute("aria-hidden", false), setTimeout(() => {
      cartLiveRegionText.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");
    const cartItemList = this.querySelectorAll("#CartItem-" + line + " .loading-overlay"),
      cartDrawerItemList = this.querySelectorAll("#CartDrawer-Item-" + line + " .loading-overlay");
    [...cartItemList, ...cartDrawerItemList].forEach(overlay => overlay.classList.remove("hidden")), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
    const cartItemList = this.querySelectorAll("#CartItem-" + line + " .loading-overlay"),
      cartDrawerItemList = this.querySelectorAll("#CartDrawer-Item-" + line + " .loading-overlay");
    cartItemList.forEach(cartItem => cartItem.classList.add("hidden")), cartDrawerItemList.forEach(cartDrawerItem => cartDrawerItem.classList.add("hidden"));
  }
  clearCart() {
    const cartErrors = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (cartErrors) cartErrors.textContent = "";
    const json = JSON.stringify({
      "sections": this.getSectionsToRender().map(section => section.section),
      "sections_url": window.location.pathname
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        "body": json
      }
    }).then(response => {
      return response.text();
    }).then(async responseText => {
      const data = JSON.parse(responseText);
      if (!data.sections) try {
        const sectionsToRender = this.getSectionsToRender().map(section => section.id).join(","),
          response = await fetch(routes.cart_url + "?sections=" + sectionsToRender),
          sectionsText = await response.text();
        try {
          const data2 = JSON.parse(sectionsText);
          data.sections = data2;
        } catch (error) {
          console.error("Clear cart fallback JSON parse failed", error), window.location.reload();
          return;
        }
      } catch (error) {
        console.error("Clear cart fallback failed", error);
        throw error;
      }
      this.classList.add("is-empty");
      const cartDrawer = document.querySelector("cart-drawer"),
        mainCartFooter = document.getElementById("main-cart-footer");
      if (mainCartFooter) mainCartFooter.classList.add("is-empty");
      if (cartDrawer) cartDrawer.classList.add("is-empty");
      this.getSectionsToRender().forEach(section => {
        const elementById = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementById.innerHTML = this.getSectionInnerHTML(data.sections[section.section], section.selector);
      });
      cartDrawer && trapFocus(cartDrawer.querySelector(".drawer__inner-empty"), cartDrawer.querySelector("a"));
      publish(PUB_SUB_EVENTS.cartUpdate, {
        "source": "cart-items"
      });
      if (shouldCheckGifts) checkGifts(this.isCartPage);
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach(overlay => overlay.classList.add("hidden"));
      const cartErrors2 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      cartErrors2.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
!customElements.get("cart-note") && customElements.define("cart-note", class CartNote extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", debounce(event => {
      const json = JSON.stringify({
        "note": event.target.value
      });
      fetch("" + routes.cart_update_url, {
        ...fetchConfig(),
        ...{
          "body": json
        }
      });
    }, ON_CHANGE_DEBOUNCE_TIMER));
  }
});;

function handleDiscountForm(event) {
  event.preventDefault();
  const cartDiscountFieldName = event.target.querySelector("[name=cart-discount-field]"),
    cartDiscountFormError = event.target.querySelector(".cart-discount-form__error"),
    discountCode = cartDiscountFieldName.value;
  if (discountCode === undefined || discountCode.length === 0) {
    cartDiscountFormError.style.display = "block";
    return;
  }
  cartDiscountFormError.style.display = "none";
  const checkoutDiscountPath = "/checkout?discount=",
    checkoutUrl = checkoutDiscountPath + discountCode;
  window.location.href = checkoutUrl;
}

function handleDiscountFormChange(event) {
  const cartDiscountFormErrorList = document.querySelectorAll(".cart-discount-form__error");
  cartDiscountFormErrorList.forEach(cartDiscountFormError => {
    cartDiscountFormError.style.display = "none";
  });
}
var serial = "";
class SearchForm extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input[type=\"search\"]"), this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.dataset.main === "false") serial = this.querySelector("[method=\"get\"]").dataset["nodal".replace("n", "m")];
    this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", debounce(event => {
      this.onChange(event);
    }, 300).bind(this)));
  }
  toggleResetButton() {
    const resetHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetHidden) this.resetButton.classList.remove("hidden");
    else this.input.value.length === 0 && !resetHidden && this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(event) {
    event.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super(), this.cachedResults = {}, this.predictiveSearchResults = this.querySelector("[data-predictive-search]"), this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search"), this.isOpen = false, this.abortController = new AbortController(), this.searchTerm = "", this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.input.addEventListener("focus", this.onFocus.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const query = this.getQuery();
    (!this.searchTerm || !query.startsWith(this.searchTerm)) && this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    this.updateSearchForTerm(this.searchTerm, query), this.searchTerm = query;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) event.preventDefault();
  }
  onFormReset(event) {
    super.onFormReset(event), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController(), this.closeResults(true));
  }
  onFocus() {
    const query = this.getQuery();
    if (!query.length) return;
    if (this.searchTerm !== query) this.onChange();
    else this.getAttribute("results") === "true" ? this.open() : this.getSearchResults(this.searchTerm);
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();
    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(event) {
    (event.code === "ArrowUp" || event.code === "ArrowDown") && event.preventDefault();
  }
  updateSearchForTerm(previousTerm, newTerm) {
    const dataPredictiveSearchSearchForText = this.querySelector("[data-predictive-search-search-for-text]"),
      itemText = dataPredictiveSearchSearchForText?.innerText;
    if (itemText) {
      if (itemText.match(new RegExp(previousTerm, "g")).length > 1) return;
      const highlightedText = itemText.replace(previousTerm, newTerm);
      dataPredictiveSearchSearchForText.innerText = highlightedText;
    }
  }
  switchOption(direction) {
    if (!this.getAttribute("open")) return;
    const movingUp = direction === "up",
      ariaSelected = this.querySelector("[aria-selected=\"true\"]"),
      liButtonPredictiveSearchItemList = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(option => option.offsetParent !== null);
    let nextIndex = 0;
    if (movingUp && !ariaSelected) return;
    let activeIndex = -1,
      i = 0;
    while (activeIndex === -1 && i <= liButtonPredictiveSearchItemList.length) {
      liButtonPredictiveSearchItemList[i] === ariaSelected && (activeIndex = i), i++;
    }
    this.statusElement.textContent = "";
    if (!movingUp && ariaSelected) nextIndex = activeIndex === liButtonPredictiveSearchItemList.length - 1 ? 0 : activeIndex + 1;
    else movingUp && (nextIndex = activeIndex === 0 ? liButtonPredictiveSearchItemList.length - 1 : activeIndex - 1);
    if (nextIndex === activeIndex) return;
    const activeOption = liButtonPredictiveSearchItemList[nextIndex];
    activeOption.setAttribute("aria-selected", true);
    if (ariaSelected) ariaSelected.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", activeOption.id);
  }
  selectOption() {
    const ariaSelected = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (ariaSelected) ariaSelected.click();
  }
  getSearchResults(searchTerm) {
    const cacheKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[cacheKey]) {
      this.renderSearchResults(this.cachedResults[cacheKey]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(searchTerm) + "&section_id=predictive-search", {
      "signal": this.abortController.signal
    }).then(response => {
      if (!response.ok) {
        var errorInstance = new Error(response.status);
        this.close();
        throw errorInstance;
      }
      return response.text();
    }).then(html => {
      const parsedDoc = new DOMParser().parseFromString(html, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(allPredictiveSearchInstance => {
        allPredictiveSearchInstance.cachedResults[cacheKey] = parsedDoc;
      }), this.renderSearchResults(parsedDoc);
    }).catch(error => {
      if (error?.code === 20) return;
      this.close();
      throw error;
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status"), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", true);
  }
  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = statusText, setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup, this.setAttribute("results", true), this.setLiveRegionResults(), this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    return this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom, this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px", this.setAttribute("open", true), this.input.setAttribute("aria-expanded", true), this.isOpen = true;
  }
  close(event = false) {
    this.closeResults(event), this.isOpen = false;
  }
  closeResults(clearSearchTerm = false) {
    clearSearchTerm && (this.input.value = "", this.removeAttribute("results"));
    const ariaSelected = this.querySelector("[aria-selected=\"true\"]");
    if (ariaSelected) ariaSelected.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", false), this.resultsMaxHeight = false, this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super(), this.upsellHandles = this.getUpsellHandles(), this.quantityGifts = document.querySelector(".quantity-gifts"), this.checkForClear(), this.addEventListener("keyup", event => event.code === "Escape" && this.close()), this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), this.setHeaderCartIconAccessibility(), this.cartBodyScroll = 0;
  }
  setHeaderCartIconAccessibility() {
    let cartIconBubble = document.querySelector("#cart-icon-bubble");
    if (!cartIconBubble) return;
    if (cartIconBubble.tagName == "DIV") cartIconBubble = cartIconBubble.closest(".header__icon--cart");
    if (!cartIconBubble) return;
    const headerIcons = cartIconBubble.closest(".header__icons");
    cartIconBubble.setAttribute("role", "button"), cartIconBubble.setAttribute("aria-haspopup", "dialog"), cartIconBubble.addEventListener("click", event => {
      event.preventDefault(), this.open(cartIconBubble);
    }), this.oseid = headerIcons.querySelector("form").dataset[this.dataset.type], cartIconBubble.addEventListener("keydown", event => {
      event.code.toUpperCase() === "SPACE" && (event.preventDefault(), this.open(cartIconBubble));
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const id = this.querySelector("[id^=\"Details-\"] summary");
    if (id && !id.hasAttribute("role")) this.setSummaryAccessibility(id);
    setTimeout(() => {
      this.classList.add("animate", "active");
    }), this.addEventListener("transitionend", () => {
      const focusContainer = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"),
        drawerInner = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(focusContainer, drawerInner);
    }, {
      "once": true
    }), document.body.classList.add("overflow-hidden");
    const countdownTimer = this.querySelector("countdown-timer");
    if (countdownTimer) countdownTimer.playTimer();
  }
  close() {
    this.classList.remove("active"), removeTrapFocus(this.activeElement), document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const cartDrawerUpsellDataToggleList = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift"),
      handles = [];
    return cartDrawerUpsellDataToggleList.forEach(cartDrawerUpsellDataToggle => {
      cartDrawerUpsellDataToggle.dataset.handle && handles.push(cartDrawerUpsellDataToggle.dataset.handle);
    }), handles;
  }
  oneNonUpellRemaining() {
    const cartItemList = this.querySelectorAll(".cart-item");
    let upsellCount = 0;
    return cartItemList.forEach(cartItem => {
      this.upsellHandles.forEach(upsellHandle => {
        cartItem.classList.contains("cart-item--product-" + upsellHandle) && upsellCount++;
      });
    }), cartItemList.length - upsellCount <= 1;
  }
  checkForClear() {
    const oneNonUpellRemainingResult = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(removeButton => {
      oneNonUpellRemainingResult ? removeButton.clearCart = true : removeButton.clearCart = false;
    });
  }
  setSummaryAccessibility(summary) {
    summary.setAttribute("role", "button"), summary.setAttribute("aria-expanded", "false"), summary.nextElementSibling.getAttribute("id") && summary.setAttribute("aria-controls", summary.nextElementSibling.id), summary.addEventListener("click", event => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    }), summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(parsedState, isCartUpsell = false) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty"), this.productId = parsedState.id, this.getSectionsToRender().forEach(section => {
      const sectionEl = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionEl) {
        sectionEl.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        const cartDrawerBody = sectionEl.querySelector(".cart-drawer__body");
        if (cartDrawerBody) cartDrawerBody.scrollTop = this.cartBodyScroll;
      }
    }), this.checkForClear();
    const countdownTimer = this.querySelector("countdown-timer");
    if (countdownTimer && countdownTimer.playTimer) countdownTimer.playTimer();
    let giftsToAdd = [],
      giftsToRemove = [];
    this.querySelectorAll("cart-drawer-gift").forEach(giftEl => {
      giftEl.getUpdateRequired() && (this.querySelector(".cart-item--product-" + giftEl.dataset.handle) ? giftEl.dataset.selected === "false" && giftsToRemove.push(giftEl) : giftEl.dataset.selected === "true" && giftsToAdd.push(giftEl));
    });
    if (giftsToRemove.length > 0) giftsToRemove[0].removeFromCart();
    else {
      if (giftsToAdd.length > 0) giftsToAdd[0].addToCart();
      else {
        if (this.quantityGifts) this.quantityGifts.initUnlock();
        const quantityBreakUpsellsList = document.querySelectorAll("quantity-break-upsells");
        quantityBreakUpsellsList.forEach(quantityBreakUpsell => {
          quantityBreakUpsell.initUnlock();
        });
      }
    }
    validateCartGifts(), setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (isCartUpsell) return;
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    let parsedDoc = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    selector === "#CartDrawer" && fixParsedHtml(this, parsedDoc);
    let html2 = parsedDoc.innerHTML;
    return html2;
  }
  getSectionsToRender() {
    return [{
      "id": "cart-drawer",
      "selector": "#CartDrawer"
    }, {
      "id": "cart-icon-bubble"
    }];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super(), this.cartDrawer = document.querySelector("cart-drawer"), this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      "method": "POST",
      "headers": {
        "Content-Type": "application/json"
      },
      "body": JSON.stringify({
        "updates": {},
        "sections": ["cart-drawer", "cart-icon-bubble"],
        "sections_url": window.location.pathname
      })
    }).then(response => response.json()).then(cartData => {
      document.querySelector("cart-drawer").renderContents(cartData, true);
    }).catch(error => {
      console.error(error);
    });
  }
  getSectionInnerHTML(html, selector) {
    let parsedDoc = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    selector === ".drawer__inner" && fixParsedHtml(this.cartDrawer, parsedDoc);
    let html2 = parsedDoc.innerHTML;
    return html2;
  }
  getSectionsToRender() {
    return [{
      "id": "CartDrawer",
      "section": "cart-drawer",
      "selector": ".drawer__inner"
    }, {
      "id": "cart-icon-bubble",
      "section": "cart-icon-bubble",
      "selector": ".shopify-section"
    }];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);

function fixParsedHtml(currentBody, newBody) {
  const cartDrawerBody = currentBody.querySelector(".cart-drawer__body");
  if (cartDrawerBody) {
    const cartDrawer = document.querySelector("cart-drawer");
    cartDrawer.cartBodyScroll = cartDrawerBody.scrollTop;
  }
  const cartTimer = newBody.querySelector(".cart-timer");
  if (cartTimer) {
    oldTimer = currentBody.querySelector(".cart-timer");
    if (oldTimer) cartTimer.innerHTML = oldTimer.innerHTML;
  }
  const cartDrawerUpsellDataToggleList = currentBody.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let cartDrawerUpsellDataToggleList2 = newBody.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  cartDrawerUpsellDataToggleList.forEach((oldUpsell, index) => {
    let newUpsell = cartDrawerUpsellDataToggleList2[index];
    if (!newUpsell) return;
    if (oldUpsell.nodeName.toLowerCase() === "cart-drawer-upsell") newUpsell.dataset.selected = oldUpsell.dataset.selected;
    newUpsell.dataset.id = oldUpsell.dataset.id, newUpsell.querySelector("[name=\"id\"]").value = oldUpsell.querySelector("[name=\"id\"]").value;
    if (newUpsell.querySelector(".upsell__image__img")) newUpsell.querySelector(".upsell__image__img").src = oldUpsell.querySelector(".upsell__image__img").src;
    if (newUpsell.querySelector(".upsell__variant-picker")) {
      const selectSelectList = oldUpsell.querySelectorAll(".select__select");
      newUpsell.querySelectorAll(".select__select").forEach((select, selectIndex) => {
        select.value = selectSelectList[selectIndex].value, select.querySelectorAll("option").forEach(option => {
          option.removeAttribute("selected");
          if (option.value === selectSelectList[selectIndex].value.trim()) option.setAttribute("selected", "");
        });
      });
    }
    if (oldUpsell.dataset.updatePrices === "true") {
      var upsellPrice = newUpsell.querySelector(".upsell__price"),
        upsellPrice2 = oldUpsell.querySelector(".upsell__price");
      if (upsellPrice && upsellPrice2) upsellPrice.innerHTML = upsellPrice2.innerHTML;
    }
  });
}!customElements.get("product-form") && customElements.define("product-form", class ProductForm extends HTMLElement {
  constructor() {
    super(), this.form = this.querySelector("form"), this.form.addEventListener("submit", this.handleSubmit.bind(this)), this.formIdInput = this.form.querySelector("[name=id]"), this.formIdInput.disabled = false, this.isMain = this.classList.contains("main-product-form"), this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [], this.skipCart = this.formIdInput.dataset.skipCart === "true", this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification"), this.isCartUpsell = this.dataset.isCartUpsell === "true", this.submitButton = this.querySelector("[type=\"submit\"]");
    if (document.querySelector("cart-drawer")) {
      if (this.submitButton) this.submitButton.setAttribute("aria-haspopup", "dialog");
      this.hasDrawer = true;
    }
    if (this.submitButton) this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
    this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section), this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section), this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section), this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    if (this.quantityBreaks) this.quantityBreakUpsells = this.quantityBreaks.querySelectorAll("quantity-break-upsells");
    this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section), this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']"), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section), this.variantInputs = this.form.querySelector(".product-form__variants");
  }
  handleSubmit(event) {
    let submitButton = null,
      skipRedirect = false;
    event && (event.preventDefault(), event.currentTarget.classList.contains("button--has-spinner") && (submitButton = event.currentTarget, submitButton.classList.add("loading")), event.currentTarget.dataset.skipCartButton === "true" && (skipRedirect = true));
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;
    this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", true);
    if (!submitButton) {
      this.submitButton.classList.add("loading");
      if (this.loadingSpinner) this.loadingSpinner.classList.remove("hidden");
    }
    this.additionalAtcButtons.forEach(additionalAtcButton => {
      additionalAtcButton.setAttribute("disabled", "");
    });
    this.displayedSubmitButton && (this.displayedSubmitButton.setAttribute("disabled", ""), this.displayedSubmitButton.classList.add("loading"));
    let variantsRendered = false,
      hasBundleItems = false;
    if (this.variantInputs && !this.ref) {
      this.variantInputs.innerHTML = "";
      let hiddenInputsHtml = "";
      const lineItems = [],
        set = new Set(),
        normalizePlan = plan => {
          const trim = plan == null ? "" : String(plan).trim();
          return trim === "" ? null : trim;
        },
        addLineItem = (variantId, quantity = 1, sellingPlan = null) => {
          if (!variantId) return;
          const variantIdText = String(variantId),
            qty = Number(quantity) || 1,
            planId = normalizePlan(sellingPlan),
            existingIndex = lineItems.findIndex(lineItem => {
              const itemPlanId = normalizePlan(lineItem.selling_plan);
              return lineItem.id === variantIdText && itemPlanId === planId;
            });
          if (existingIndex === -1) {
            const newLineItem = {
              "id": variantIdText,
              "quantity": qty
            };
            if (planId) newLineItem.selling_plan = planId;
            lineItems.push(newLineItem);
          } else lineItems[existingIndex].quantity += qty;
        },
        trackVariant = id => {
          if (id) set.add(String(id));
        };
      this.hasDrawer && !this.isCartUpsell && !this.skipCart && this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(upsellEl => {
        if (upsellEl.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + upsellEl.dataset.handle)) {
          const inputName = upsellEl.querySelector("input[name=\"selling_plan\"]")?.value || null;
          addLineItem(upsellEl.dataset.id, 1, inputName);
        }
      });
      if (this.bundleDeals) this.dataset.includePdpUpsells === "true" && document.querySelectorAll("product-info-upsell").forEach(upsellEl => {
        const inputName = upsellEl.querySelector("input[name=\"selling_plan\"]")?.value || null;
        if (upsellEl.dataset.selected === "true") addLineItem(upsellEl.dataset.id, 1, inputName);
      }), (this.bundleDeals.formVariants || []).forEach(formVariant => {
        if (!formVariant) return;
        addLineItem(formVariant.id, Number(formVariant.quantity) || 1);
      });
      else {
        this.quantityGifts && Array.isArray(this.quantityGifts.unlockedItems) && this.quantityGifts.unlockedItems.length > 0 && this.quantityGifts.unlockedItems.forEach(unlockedItem => addLineItem(unlockedItem, 1));
        this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
        for (let giftsToMonitorVar = this.upsells.length - 1; giftsToMonitorVar >= 0; giftsToMonitorVar--) {
          const upsells = this.upsells[giftsToMonitorVar];
          if (upsells && upsells.dataset.selected === "true") {
            const inputName = upsells.querySelector("input[name=\"selling_plan\"]")?.value || null;
            addLineItem(upsells.dataset.id, 1, inputName);
          }
        }
        this.quantityBreakUpsells && this.quantityBreakUpsells.forEach(quantityBreakUpsell => {
          (quantityBreakUpsell.unlockedItems || []).forEach(unlockedId => {
            const unlockedIdText = String(unlockedId);
            !lineItems.some(lineItem => String(lineItem.id) === unlockedIdText) && addLineItem(unlockedIdText, 1);
          });
        });
        if (this.mainBundleItems.length === 0) {
          if (this.quantityBreaks && Array.isArray(this.quantityBreaks.formVariants) && this.quantityBreaks.formVariants.length > 0) this.quantityBreaks.formVariants.forEach(formVariant => {
            addLineItem(formVariant, 1), trackVariant(formVariant);
          }), hasBundleItems = true;
          else {
            let selectedQuantity = 1;
            if (this.quantityBreaks) selectedQuantity = Number(this.quantityBreaks.selectedQuantity) || 1;
            else {
              if (this.quantityPicker) selectedQuantity = Number(this.quantityPicker.querySelector(".quantity__input")?.value) || 1;
              else this.querySelector("input[name=\"quantity\"]") && (selectedQuantity = Number(this.querySelector("input[name=\"quantity\"]").value) || 1);
            }
            const formIdInput = this.formIdInput.value;
            addLineItem(formIdInput, selectedQuantity), trackVariant(formIdInput);
          }
        }
        for (let giftsToMonitorVar = this.mainBundleItems.length - 1; giftsToMonitorVar >= 0; giftsToMonitorVar--) {
          const mainBundleItems = this.mainBundleItems[giftsToMonitorVar];
          addLineItem(mainBundleItems.dataset.id, 1), (mainBundleItems.dataset.isMainPdpProduct === undefined || mainBundleItems.dataset.isMainPdpProduct === "true") && trackVariant(mainBundleItems.dataset.id);
        }
      }
      if (lineItems.length > 1 || hasBundleItems || this.bundleDeals || this.mainBundleItems.length > 0) {
        const customFieldValues = [];
        this.customFields?.forEach(customField => {
          customField?.dataset?.disabled !== "true" && customFieldValues.push({
            "fieldName": customField.fieldName,
            "value": customField.prevValue
          });
        });
        let input = null;
        this.classList.contains("main-product-form") && (input = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"], skio-plan-picker [name=\"selling_plan\"]"));
        const simpleBundlesIoOptions = this.querySelector("#simple-bundles-io-options"),
          propertySelector = "input[name^=\"properties[\"]:not(#validator):not(.spx-property-input):not([type=\"radio\"]),input[name^=\"properties[\"][type=\"radio\"]:checked:not(#validator):not(.spx-property-input),select[name^=\"properties[\"]:not(#validator):not(.spx-property-input)",
          propertyInputs = this.classList.contains("main-product-form") ? this.productInfo ? this.productInfo.querySelectorAll(propertySelector) : document.querySelectorAll(propertySelector) : [];
        lineItems.forEach(lineItem => {
          if (set.has(lineItem.id)) {
            const properties = [];
            customFieldValues.forEach(fieldValue => {
              properties.push({
                "fieldName": fieldValue.fieldName,
                "value": fieldValue.value
              });
            });
            simpleBundlesIoOptions && simpleBundlesIoOptions.querySelectorAll("select[name^=\"properties[\"], input[name^=\"properties[\"]").forEach(input2 => {
              const matchResult = input2.name.match(/properties\[(.*?)\]/);
              if (matchResult) properties.push({
                "fieldName": matchResult[1],
                "value": input2.value
              });
            });
            this.classList.contains("main-product-form") && propertyInputs.forEach(propertyInput => {
              const matchResult = propertyInput.name.match(/properties\[(.*?)\]/);
              matchResult && (propertyInput.type === "file" ? propertyInput.files && propertyInput.files.length > 0 && properties.push({
                "fieldName": matchResult[1],
                "value": propertyInput.files[0],
                "isFile": true
              }) : properties.push({
                "fieldName": matchResult[1],
                "value": propertyInput.value
              }));
            });
            if (properties.length) lineItem.properties = properties;
            input && typeof input.value === "string" && input.value.length > 0 && (lineItem.selling_plan = input.value);
          }
        });
        const createDocumentFragmentResult = document.createDocumentFragment(),
          fileProps = [];
        lineItems.forEach((lineItem, index) => {
          hiddenInputsHtml += "<input type=\"hidden\" name=\"items[" + index + "][quantity]\" value=\"" + lineItem.quantity + "\">" + ("<input type=\"hidden\" name=\"items[" + index + "][id]\" value=\"" + lineItem.id + "\">"), lineItem.selling_plan && (hiddenInputsHtml += "<input type=\"hidden\" name=\"items[" + index + "][selling_plan]\" value=\"" + lineItem.selling_plan + "\">"), Array.isArray(lineItem.properties) && lineItem.properties.length && lineItem.properties.forEach(property => {
            if (property.isFile) fileProps.push({
              "name": "items[" + index + "][properties][" + property.fieldName + "]",
              "file": property.value
            });
            else {
              const inputEl = document.createElement("input");
              inputEl.type = "hidden", inputEl.name = "items[" + index + "][properties][" + property.fieldName + "]", inputEl.value = serializePropValue(property.value), createDocumentFragmentResult.appendChild(inputEl);
            }
          });
        }), this._filePropsForFormData = fileProps, this.variantInputs.innerHTML = hiddenInputsHtml, this.variantInputs.appendChild(createDocumentFragmentResult), variantsRendered = true;
      }
    }
    var fetchOptions = fetchConfig("javascript");
    fetchOptions.headers["X-Requested-With"] = "XMLHttpRequest", delete fetchOptions.headers["Content-Type"];
    var formData = new FormData(this.form);
    this._filePropsForFormData && this._filePropsForFormData.length > 0 && (this._filePropsForFormData.forEach(({
      name: name,
      file: file
    }) => {
      formData.append(name, file);
    }), this._filePropsForFormData = []);
    if (this.ref) variantsRendered = true;
    this.cart && (formData.append("sections", this.cart.getSectionsToRender().map(section => section.id)), formData.append("sections_url", window.location.pathname), this.cart.setActiveElement(document.activeElement));
    if (variantsRendered) {
      const options = this.dataset.options ? this.dataset.options.split(",") : [],
        keysToDelete = ["id", "quantity", ...options];
      for (let giftsToMonitorVar = 0; giftsToMonitorVar < keysToDelete.length; giftsToMonitorVar++) {
        formData.delete(keysToDelete[giftsToMonitorVar]);
      }
    }
    fetchOptions.body = formData, fetch("" + routes.cart_add_url, fetchOptions).then(response => response.json()).then(async cartData => {
      if (cartData.status) {
        this.handleErrorMessage(cartData.description);
        const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
        if (!soldOutMessage) return;
        this.submitButton.setAttribute("aria-disabled", true), this.submitButton.querySelector("span").classList.add("hidden"), soldOutMessage.classList.remove("hidden"), this.error = true;
        return;
      }
      if (!cartData.sections && this.cart) try {
        const response2 = await fetch(routes.cart_url + "?sections=" + this.cart.getSectionsToRender().map(section2 => section2.id).join(",")),
          sectionsText = await response2.text();
        try {
          const data = JSON.parse(sectionsText);
          cartData.sections = data;
        } catch (error) {
          console.error("Add to cart fallback JSON parse failed", error), window.location = window.routes.cart_url;
          return;
        }
      } catch (error) {
        console.error("Add to cart fallback failed", error), this.handleErrorMessage(window.cartStrings.error || "Something went wrong.");
        return;
      }
      if (this.skipCart || skipRedirect) {
        window.location = "/checkout";
        return;
      } else {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
      }
      if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
        "source": "product-form",
        "productVariantId": this.formIdInput.id,
        "cartData": cartData
      });
      this.error = false;
      const quickAddModal = this.closest("quick-add-modal");
      quickAddModal ? (document.body.addEventListener("modalClosed", () => {
        setTimeout(() => {
          this.cart.renderContents(cartData, this.isCartUpsell);
        });
      }, {
        "once": true
      }), quickAddModal.hide(true)) : this.cart.renderContents(cartData, this.isCartUpsell);
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      if (submitButton) submitButton.classList.remove("loading");
      else {
        this.submitButton.classList.remove("loading");
        if (this.loadingSpinner) this.loadingSpinner.classList.add("hidden");
      }
      this.additionalAtcButtons.forEach(additionalAtcButton => {
        additionalAtcButton.removeAttribute("disabled");
      });
      this.displayedSubmitButton && (this.displayedSubmitButton.removeAttribute("disabled"), this.displayedSubmitButton.classList.remove("loading"));
      if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
      if (!this.error) this.submitButton.removeAttribute("aria-disabled");
    });
  }
  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage), errorMessage && (this.errorMessage.textContent = errorMessage);
  }
});

function serializePropValue(propValue) {
  if (propValue == null) return "";
  if (typeof propValue === "object") try {
    return JSON.stringify(propValue);
  } catch {
    return String(propValue);
  }
  return String(propValue);
}!customElements.get("product-info") && customElements.define("product-info", class ProductInfo extends HTMLElement {
  constructor() {
    super(), this.deferredMedia = document.querySelector("[" + defMed + "]"), this.input = this.querySelector(".quantity__input"), this.currentVariant = this.querySelector(".product-variant-id"), this.variantSelects = this.querySelector("variant-radios"), this.submitButton = this.querySelector("[type=\"submit\"]"), this.form = this.querySelector("#ProductForm-" + this.dataset.section), this.hasUrl = this.dataset.url !== null;
  }
  cartUpdateUnsubscriber = undefined;
  variantChangeUnsubscriber = undefined;
  connectedCallback() {
    if (!this.form) return;
    if (!this.input) return;
    this.quantityForm = this.querySelector(".product-form__quantity");
    if (!this.quantityForm) return;
    this.setQuantityBoundries(), !this.dataset.originalSection && (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))), this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const dataset = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
      if (event.data.sectionId !== dataset) return;
      this.updateQuantityRules(event.data.sectionId, event.data.html), this.setQuantityBoundries();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(), this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
  }
  setQuantityBoundries() {
    const input = {
      "cartQuantity": this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
      "min": this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
      "max": this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
      "step": this.input.step ? parseInt(this.input.step) : 1
    };
    let min = input.min;
    const max = input.max === null ? input.max : input.max - input.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (input.cartQuantity >= input.min) min = Math.min(min, input.step);
    const currentQuantity = parseInt(this.input.value) || min;
    let boundedQuantity = currentQuantity;
    if (boundedQuantity < min) boundedQuantity = min;
    if (max !== null && boundedQuantity > max) boundedQuantity = max;
    this.input.min = min, this.input.max = max, this.input.value = boundedQuantity, publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
  }
  initShareLinks() {
    const shareUrlButton = this.querySelector(".share-url-button");
    if (!shareUrlButton) this.shareUrl = true;
  }
  fetchQuantityRules() {
    if (!this.currentVariant || !this.currentVariant.value) return;
    this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"), fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(response => {
      return response.text();
    }).then(html => {
      const parsedDoc = new DOMParser().parseFromString(html, "text/html");
      this.updateQuantityRules(this.dataset.section, parsedDoc), this.setQuantityBoundries();
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
    });
  }
  updateQuantityRules(parsedState, name) {
    const quantityForm = name.getElementById("Quantity-Form-" + parsedState);
    if (quantityForm && this.quantityForm) {
      const quantity__input = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let giftsToMonitorVar of quantity__input) {
        const currentInput = this.quantityForm.querySelector(giftsToMonitorVar),
          updatedInput = quantityForm.querySelector(giftsToMonitorVar);
        if (!currentInput || !updatedInput) continue;
        if (giftsToMonitorVar === ".quantity__input") {
          const attributesToSync = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let giftsToMonitorVar2 of attributesToSync) {
            const attribute = updatedInput.getAttribute(giftsToMonitorVar2);
            if (attribute !== null) currentInput.setAttribute(giftsToMonitorVar2, attribute);
          }
        } else currentInput.innerHTML = updatedInput.innerHTML;
      }
    }
  }
});;

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(summary => {
  summary.setAttribute("role", "button"), summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));
  summary.nextElementSibling?.getAttribute("id") && summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  summary.addEventListener("click", event => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });
  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var getFocusableElementsResult = getFocusableElements(container),
    firstFocusable = getFocusableElementsResult[0],
    lastFocusable = getFocusableElementsResult[getFocusableElementsResult.length - 1];
  removeTrapFocus(), trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== lastFocusable && event.target !== firstFocusable) return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== "TAB") return;
    event.target === lastFocusable && !event.shiftKey && (event.preventDefault(), firstFocusable.focus()), (event.target === container || event.target === firstFocusable) && event.shiftKey && (event.preventDefault(), lastFocusable.focus());
  }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), elementToFocus.focus(), elementToFocus.tagName === "INPUT" && ["search", "text", "email", "url"].includes(elementToFocus.type) && elementToFocus.value && elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(youtubeFrame => {
    youtubeFrame.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  }), document.querySelectorAll(".js-vimeo").forEach(vimeoFrame => {
    vimeoFrame.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  }), document.querySelectorAll("media-gallery template video").forEach(video => video.pause()), document.querySelectorAll("product-model").forEach(productModel => {
    if (productModel.modelViewerUI) productModel.modelViewerUI.pause();
  });
}
var menuIndex = "body",
  linkContent = "innerHTML";

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetails = event.target.closest("details[open]");
  if (!openDetails) return;
  const summary = openDetails.querySelector("summary");
  openDetails.removeAttribute("open"), summary.setAttribute("aria-expanded", false), summary.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      "bubbles": true
    }), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.input.addEventListener("change", this.onInputChange.bind(this)), this.querySelectorAll("button").forEach(button => button.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules(), this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const input = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (input !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const quantity = parseInt(this.input.value);
    if (this.input.min) {
      const minValue = parseInt(this.input.min),
        quantityButtonMinusName = this.querySelector(".quantity__button[name='minus']");
      quantityButtonMinusName.classList.toggle("disabled", quantity <= minValue);
    }
    if (this.input.max) {
      const maxValue = parseInt(this.input.max),
        quantityButtonPlusName = this.querySelector(".quantity__button[name='plus']");
      quantityButtonPlusName.classList.toggle("disabled", quantity >= maxValue);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) this.quantityGifts.unlockGifts(quantity);
  }
}
customElements.define("quantity-input", QuantityInput);

function debounce(event, event2) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId), timeoutId = setTimeout(() => event.apply(this, args), event2);
  };
}

function fetchConfig(type = "json") {
  return {
    "method": "POST",
    "headers": {
      "Content-Type": "application/json",
      "Accept": "application/" + type
    }
  };
}

function addDays(dateVar, days) {
  var dateVar2 = new Date(dateVar);
  return dateVar2.setDate(dateVar2.getDate() + days), dateVar2;
}

function formatDates(dateVar, format, maxDays = 27) {
  if (!dateVar || !format) return;
  const dateVar2 = new Date(format + "T00:00:00Z"),
    fullYear = dateVar2.getFullYear(),
    month = dateVar2.getMonth(),
    dateVar3 = dateVar2.getDate(),
    dateVar4 = new Date(fullYear, month, dateVar3),
    diffMs = dateVar - dateVar4,
    diffDays = Math.ceil(diffMs / (1000 * 3600 * 24));
  return diffDays <= maxDays;
}

function checkDateValidity(dateVar) {
  const dateVar2 = new Date(dateVar),
    dateVar3 = new Date("2023-01-01T00:00:00Z"),
    absResult = Math.abs(dateVar2.getDate() - dateVar3.getDate());
  return absResult % 5 === 0 ? true : false;
}
typeof window.Shopify == "undefined" && (window.Shopify = {});
Shopify.bind = function(fn, context) {
  return function() {
    return fn.apply(context, arguments);
  };
}, Shopify.setSelectorByValue = function(selector, value) {
  for (var giftsToMonitorVar = 0, giftsToMonitorVar2 = selector.options.length; giftsToMonitorVar < giftsToMonitorVar2; giftsToMonitorVar++) {
    var options = selector.options[giftsToMonitorVar];
    if (value == options.value || value == options.innerHTML) return selector.selectedIndex = giftsToMonitorVar, giftsToMonitorVar;
  }
}, Shopify.addListener = function(target, eventName, handler) {
  target.addEventListener ? target.addEventListener(eventName, handler, false) : target.attachEvent("on" + eventName, handler);
}, Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options.method || "post",
    parameters = options.parameters || {},
    formEl = document.createElement("form");
  formEl.setAttribute("method", method), formEl.setAttribute("action", path);
  for (var giftsToMonitorVar in parameters) {
    var inputEl = document.createElement("input");
    inputEl.setAttribute("type", "hidden"), inputEl.setAttribute("name", giftsToMonitorVar), inputEl.setAttribute("value", parameters[giftsToMonitorVar]), formEl.appendChild(inputEl);
  }
  document.body.appendChild(formEl), formEl.submit(), document.body.removeChild(formEl);
}, Shopify.internationalAccessAccept = (function() {
  function isSupportedLanguage() {
    var language = navigator.language || navigator.userLanguage;
    return language.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
  }

  function isValidHost() {
    var DateTimeFormatResult = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return DateTimeFormatResult.startsWith("Europe") || DateTimeFormatResult.startsWith("America") || DateTimeFormatResult.includes("GMT");
  }

  function hasSimpleCurrencySymbol() {
    var currencySymbol = Shopify.currency.symbol || "$";
    return currencySymbol.length === 1;
  }

  function checkEnvironment() {
    var stored = localStorage.getItem(POST_LINK_INT),
      postLink = Shopify.postLink ? Shopify.postLink.toString().length : 0;
    if (stored === null) return localStorage.setItem(POST_LINK_INT, postLink.toString()), true;
    return parseInt(stored) === postLink;
  }

  function checkLanguage() {
    return isSupportedLanguage() || isValidHost() && hasSimpleCurrencySymbol();
  }

  function checkHost() {
    return window.performance && typeof window.performance.timing === "object";
  }
  return function() {
    var languageOk = checkLanguage(),
      hostOk = checkHost(),
      environmentOk = checkEnvironment();
    return Shopify.postLinksRetry = !environmentOk, languageOk && hostOk && environmentOk;
  };
}()), Shopify.CountryProvinceSelector = function(countryDomId, provinceDomId, options) {
  this.countryEl = document.getElementById(countryDomId), this.provinceEl = document.getElementById(provinceDomId), this.provinceContainer = document.getElementById(options.hideElement || provinceDomId), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince();
}, Shopify.CountryProvinceSelector.prototype = {
  "initCountry": function() {
    var defaultVar = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, defaultVar), this.countryHandler();
  },
  "initProvince": function() {
    var defaultVar = this.provinceEl.getAttribute("data-default");
    defaultVar && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, defaultVar);
  },
  "countryHandler": function(event) {
    var countryEl = this.countryEl.options[this.countryEl.selectedIndex],
      provinces = countryEl.getAttribute("data-provinces"),
      data = JSON.parse(provinces);
    this.clearOptions(this.provinceEl);
    if (data && data.length == 0) this.provinceContainer.style.display = "none";
    else {
      for (var giftsToMonitorVar = 0; giftsToMonitorVar < data.length; giftsToMonitorVar++) {
        var optionEl = document.createElement("option");
        optionEl.value = data[giftsToMonitorVar][0], optionEl.innerHTML = data[giftsToMonitorVar][1], this.provinceEl.appendChild(optionEl);
      }
      this.provinceContainer.style.display = "";
    }
  },
  "clearOptions": function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  "setOptions": function(selector, values) {
    for (var giftsToMonitorVar = 0, giftsToMonitorVar2 = values.length; giftsToMonitorVar < values.length; giftsToMonitorVar++) {
      var optionEl = document.createElement("option");
      optionEl.value = values[giftsToMonitorVar], optionEl.innerHTML = values[giftsToMonitorVar], selector.appendChild(optionEl);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super(), this.playButton = this.querySelector(".internal-video__play"), this.noPlayBtn = this.dataset.noPlayBtn === "true", this.loaded = false, this.suspended = false, this.soundButton = this.querySelector(".internal-video__sound-btn"), this.video = this.querySelector("video"), this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) this.invalidFormatSrc.remove();
    this.timeline = this.querySelector(".internal-video__timeline"), this.dragging = false, this.fullscreenButton = this.querySelector(".internal-video__fullscreen-btn");
    if (this.playButton) this.playButton.addEventListener("click", this.playVideo.bind(this));
    if (this.soundButton) this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    if (this.video) this.video.addEventListener("ended", this.endedVideo.bind(this));
    this.timeline && (this.video.addEventListener("timeupdate", this.updateTimeline.bind(this)), this.timeline.addEventListener("click", this.seekVideo.bind(this)), this.timeline.addEventListener("mousedown", this.startDrag.bind(this)), this.timeline.addEventListener("touchstart", this.startDrag.bind(this)), document.addEventListener("mouseup", this.stopDrag.bind(this)), document.addEventListener("touchend", this.stopDrag.bind(this)), document.addEventListener("mousemove", this.drag.bind(this)), document.addEventListener("touchmove", this.drag.bind(this)));
    this.video.addEventListener("waiting", this.showSpinner.bind(this)), this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this)), this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const observerOptions = {
        "root": null,
        "rootMargin": "0px",
        "threshold": 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions), this.observer.observe(this);
    }
    this.fullscreenButton && (this.fullscreenButton.addEventListener("click", this.toggleFullscreen.bind(this)), document.addEventListener("fullscreenchange", this.handleFullscreenChange.bind(this)));
  }
  playVideo() {
    if (this.video.paused) {
      !this.loaded && (this.video.load(), this.loaded = true);
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      const playResult = this.video.play();
      playResult !== undefined && playResult.then(() => {
        this.classList.add("internal-video--playing");
        if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      }).catch(error => {
        this.classList.remove("internal-video--playing");
        if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
      });
    } else this.video.pause(), this.classList.remove("internal-video--playing");
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted ? (this.video.muted = false, this.classList.remove("internal-video--muted")) : (this.video.muted = true, this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const video = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", video + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(event) {
    event.preventDefault(), this.dragging = true, this.drag(event);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(event) {
    if (!this.dragging) return;
    event.touches && (event = event.touches[0]), this.seekVideo(event);
  }
  seekVideo(event) {
    const boundingClientRect = this.timeline.getBoundingClientRect(),
      clientX = event.clientX - boundingClientRect.left,
      width = clientX / boundingClientRect.width;
    this.video.currentTime = width * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        for (let giftsToMonitorVar of this.video.querySelectorAll("source[data-src]")) {
          giftsToMonitorVar.setAttribute("src", giftsToMonitorVar.getAttribute("data-src")), giftsToMonitorVar.removeAttribute("data-src");
        }
        this.video.load();
        var playResult = this.video.play();
        playResult !== undefined && playResult.catch(error => {
          if (error.name === "NotAllowedError") {
            this.classList.remove("internal-video--playing");
            if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
          }
        }).then(() => {
          this.video.play();
        }), this.observer.disconnect();
      }
    });
  }
  toggleFullscreen() {
    document.fullscreenElement ? document.exitFullscreen() : this.requestFullscreen();
  }
  handleFullscreenChange() {
    document.fullscreenElement === this ? this.classList.add("internal-video--fullscreen") : this.classList.remove("internal-video--fullscreen");
  }
}
customElements.define("internal-video", InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super(), this.sliderOverlay = this.querySelector(".comparison-slider__overlay"), this.sliderLine = this.querySelector(".comparison-slider__line"), this.sliderInput = this.querySelector(".comparison-slider__input"), this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(event) {
    const position = event.currentTarget.value;
    this.sliderOverlay.style.width = position + "%", this.sliderLine.style.left = position + "%", this.style.setProperty("--position", position + "%");
  }
}
customElements.define("comparison-slider", ComparisonSlider);

function popupTimer() {}
class PromoPopup extends HTMLElement {
  constructor() {
    super(), this.testMode = this.dataset.testMode === "true", this.secondsDelay = this.dataset.delaySeconds, this.daysFrequency = this.dataset.delayDays, this.modal = this.querySelector(".sign-up-popup-modal"), this.timer = this.querySelector(".popup-modal__timer"), this.timerDuration = this.dataset.timerDuration, this.closeBtns = this.querySelectorAll(".promp-popup__close-btn"), this.overlay = document.querySelector(".sign-up-popup-overlay"), this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();
      else {
        const data = JSON.parse(localStorage.getItem(this.storageKey)),
          dateVar = new Date(data.next_display_date);
        currentDate.getTime() > dateVar.getTime() && this.openPopupModal();
      }
    } else {
      if (this.timer) this.displayPromoTimer();
    }
    this.closeBtns.forEach(closeBtn => {
      closeBtn.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active"), this.overlay.classList.add("popup-overlay--active");
      const addDaysResult = addDays(currentDate, parseInt(this.daysFrequency)),
        storedState = {
          "next_display_date": addDaysResult,
          "dismissed": false
        };
      localStorage.setItem(this.storageKey, JSON.stringify(storedState));
      if (this.timer) this.displayPromoTimer();
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes"), this.secondsSpan = this.querySelector(".popup-modal__timer__seconds"), this.totalSeconds = parseFloat(this.timerDuration) * 60, this.updateTimer();
    const setIntervalResult = setInterval(() => {
      this.totalSeconds -= 1, this.updateTimer(), this.totalSeconds <= 0 && (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45);
    }, 1000);
  }
  updateTimer() {
    let minutes = Math.floor(this.totalSeconds / 60);
    if (minutes.toString().length === 1) minutes = "0" + minutes;
    let totalSeconds = this.totalSeconds % 60;
    if (totalSeconds.toString().length === 1) totalSeconds = "0" + totalSeconds;
    this.minutesSpan.innerText = minutes, this.secondsSpan.innerText = totalSeconds;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active"), this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super(), this.sectionOneContainer = this.querySelector(".section-group__section-one-container"), this.sectionTwoContainer = this.querySelector(".section-group__section-two-container"), this.transferSections(), document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping"), this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) this.sectionOneContainer.appendChild(this.sectionOne);
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector(".clickable-discount__btn"), this.button.addEventListener("click", this.handleClick.bind(this)), this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    this.dataset.loading = "true", this.button.disabled = true, this.dataset.error = "false", fetch("/discount/" + this.dataset.code).then(response => {
      if (!response.ok) throw new Error("Error");
      this.dataset.applied = "true", sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    }).catch(error => {
      this.dataset.error = "true", this.button.disabled = false;
    }).finally(() => {
      this.dataset.loading = "false";
    });
  }
  reapplyDiscountIfApplicable() {
    const dataset = this.dataset.code;
    sessionStorage.getItem("discount-" + dataset + "-applied") && (this.dataset.applied = "true", this.button.disabled = true, setTimeout(() => {
      fetch("/discount/" + dataset).catch(error => {
        this.dataset.applied = "false", this.button.disabled = false;
      });
    }, 3000));
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super(), this.dateFormat = this.dataset.dateFormat, this.days = this.rearrangeDays(this.dataset.dayLabels.split(",")), this.months = this.dataset.monthLabels.split(","), this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]"), this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || ""), this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || ""), this.insertDates(), checkDateValidity(currentDate), document.addEventListener("shopify:section:load", event => {
      this.insertDates();
    });
  }
  addDaysSkipping(dateVar, days) {
    let dateVar2 = new Date(dateVar),
      remainingDays = Number(days) || 0;
    while (remainingDays > 0) {
      dateVar2 = addDays(dateVar2, 1);
      if (!this.isSkipped(dateVar2)) remainingDays--;
    }
    return dateVar2;
  }
  parseDaysToSkip(rawDays) {
    const map = new Map([
        ["sunday", 0],
        ["monday", 1],
        ["tuesday", 2],
        ["wednesday", 3],
        ["thursday", 4],
        ["friday", 5],
        ["saturday", 6]
      ]),
      set = new Set();
    if (!rawDays) return set;
    return rawDays.split(",").forEach(dayName => {
      const dayKey = dayName.trim();
      if (map.has(dayKey)) set.add(map.get(dayKey));
    }), set;
  }
  parseDatesToSkip(raw) {
    const set = new Set();
    if (!raw) return set;
    return raw.split(",").forEach(rawDate => {
      const dateText = rawDate.trim();
      if (!dateText) return;
      const parts = dateText.split("-");
      if (parts.length === 2) {
        const month = String(Math.max(1, Math.min(12, Number(parts[0])))).padStart(2, "0"),
          day = String(Math.max(1, Math.min(31, Number(parts[1])))).padStart(2, "0");
        set.add(month + "-" + day);
      } else {
        if (parts.length === 3) {
          const month = String(Math.max(1, Math.min(12, Number(parts[1])))).padStart(2, "0"),
            day = String(Math.max(1, Math.min(31, Number(parts[2])))).padStart(2, "0");
          set.add(month + "-" + day);
        }
      }
    }), set;
  }
  isSkipped(dateVar) {
    const dayIsSkipped = this.daysToSkip.has(dateVar.getDay()),
      month = String(dateVar.getMonth() + 1).padStart(2, "0"),
      day = String(dateVar.getDate()).padStart(2, "0"),
      dateIsSkipped = this.datesToSkip.has(month + "-" + day);
    return dayIsSkipped || dateIsSkipped;
  }
  nextValidDate(fromDate) {
    let dateVar = new Date(fromDate);
    while (this.isSkipped(dateVar)) {
      dateVar = addDays(dateVar, 1);
    }
    return dateVar;
  }
  insertDates() {
    this.elementsToChange.forEach(elementsToChange => {
      const template = elementsToChange.dataset.text,
        minValue = parseInt(elementsToChange.dataset.minDays),
        maxValue = parseInt(elementsToChange.dataset.maxDays),
        addDaysSkippingResult = this.addDaysSkipping(currentDate, minValue),
        addDaysSkippingResult2 = this.addDaysSkipping(currentDate, maxValue);
      let startSuffix = "th";
      const dateVar = addDaysSkippingResult.getDate();
      if ([1, 21, 31].includes(dateVar)) startSuffix = "st";
      else {
        if ([2, 22].includes(dateVar)) startSuffix = "nd";
        else {
          if ([3, 23].includes(dateVar)) startSuffix = "rd";
        }
      }
      let endSuffix = "th";
      const dateVar2 = addDaysSkippingResult2.getDate();
      if ([1, 21, 31].includes(dateVar2)) endSuffix = "st";
      else {
        if ([2, 22].includes(dateVar2)) endSuffix = "nd";
        else {
          if ([3, 23].includes(dateVar2)) endSuffix = "rd";
        }
      }
      let startDateText, endDateText;
      if (this.dateFormat === "day_dd_mm") startDateText = this.days[addDaysSkippingResult.getDay()] + ", " + addDaysSkippingResult.getDate() + ". " + this.months[addDaysSkippingResult.getMonth()], endDateText = this.days[addDaysSkippingResult2.getDay()] + ", " + addDaysSkippingResult2.getDate() + ". " + this.months[addDaysSkippingResult2.getMonth()];
      else {
        if (this.dateFormat === "mm_dd") startDateText = this.months[addDaysSkippingResult.getMonth()] + " " + addDaysSkippingResult.getDate() + startSuffix, endDateText = this.months[addDaysSkippingResult2.getMonth()] + " " + addDaysSkippingResult2.getDate() + endSuffix;
        else {
          if (this.dateFormat === "dd_mm") startDateText = addDaysSkippingResult.getDate() + ". " + this.months[addDaysSkippingResult.getMonth()], endDateText = addDaysSkippingResult2.getDate() + ". " + this.months[addDaysSkippingResult2.getMonth()];
          else {
            if (this.dateFormat === "dd_mm_no_dot") startDateText = addDaysSkippingResult.getDate() + " " + this.months[addDaysSkippingResult.getMonth()], endDateText = addDaysSkippingResult2.getDate() + " " + this.months[addDaysSkippingResult2.getMonth()];
            else {
              if (this.dateFormat === "day_dd_mm_numeric") {
                const startDay = String(addDaysSkippingResult.getDate()).padStart(2, "0"),
                  startMonth = String(addDaysSkippingResult.getMonth() + 1).padStart(2, "0");
                startDateText = this.days[addDaysSkippingResult.getDay()] + ", " + startDay + ". " + startMonth + ".";
                const endDay = String(addDaysSkippingResult2.getDate()).padStart(2, "0"),
                  endMonth = String(addDaysSkippingResult2.getMonth() + 1).padStart(2, "0");
                endDateText = this.days[addDaysSkippingResult2.getDay()] + ", " + endDay + ". " + endMonth + ".";
              } else {
                if (this.dateFormat === "dd_mm_numeric") {
                  const startDay = String(addDaysSkippingResult.getDate()).padStart(2, "0"),
                    startMonth = String(addDaysSkippingResult.getMonth() + 1).padStart(2, "0");
                  startDateText = startDay + ". " + startMonth + ".";
                  const endDay = String(addDaysSkippingResult2.getDate()).padStart(2, "0"),
                    endMonth = String(addDaysSkippingResult2.getMonth() + 1).padStart(2, "0");
                  endDateText = endDay + ". " + endMonth + ".";
                } else startDateText = this.days[addDaysSkippingResult.getDay()] + ", " + this.months[addDaysSkippingResult.getMonth()] + " " + addDaysSkippingResult.getDate() + startSuffix, endDateText = this.days[addDaysSkippingResult2.getDay()] + ", " + this.months[addDaysSkippingResult2.getMonth()] + " " + addDaysSkippingResult2.getDate() + endSuffix;
              }
            }
          }
        }
      }
      const withStartDate = template.replace("[start_date]", startDateText),
        withEndDate = withStartDate.replace("[end_date]", endDateText);
      elementsToChange.innerHTML = withEndDate;
    });
  }
  rearrangeDays(days) {
    return days.unshift(days[6]), days.length = 7, days;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super(), this.displayMode = this.dataset.displayMode || (this.dataset.afterScroll === "true" ? "after_scroll" : "always"), this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0), this.isScrollBtn = this.dataset.scrollBtn === "true", this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section), this.floatingBtns = document.querySelectorAll(".floating-btn"), this.footerSpacing();
    this.displayMode === "always" ? this.floatingBtns.forEach(floatingBtn => {
      floatingBtn.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
    }) : (this.checkScroll(), document.addEventListener("scroll", this.checkScroll.bind(this)));
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn"), this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
    }
  }
  checkScroll() {
    let shouldShow = false;
    if (this.displayMode === "after_scroll") {
      if (!this.mainAtcBtn) return;
      const boundingClientRect = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY,
        mainAtcBtn = boundingClientRect + this.mainAtcBtn.offsetHeight;
      shouldShow = window.scrollY > mainAtcBtn;
    } else {
      if (this.displayMode === "after_pixels") shouldShow = window.scrollY > this.displayThreshold;
      else {
        if (this.displayMode === "after_percent") {
          const documentElement = document.documentElement.scrollHeight - window.innerHeight;
          shouldShow = documentElement <= 0 ? true : window.scrollY / documentElement * 100 > this.displayThreshold;
        }
      }
    }
    shouldShow ? (this.style.transform = "none", this.scrolledPast = true) : (this.style.transform = "", this.scrolledPast = false), this.floatingBtns.forEach(floatingBtn => {
      floatingBtn.style.setProperty("--sticky-atc-offset", this.scrolledPast ? this.offsetHeight + "px" : "0px");
    });
  }
  handleScrollBtn() {
    const stickyHeader = document.querySelector("sticky-header"),
      clientHeight = stickyHeader ? stickyHeader.clientHeight : 0,
      boundingClientRect = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      "top": boundingClientRect - clientHeight - 15,
      "behavior": "smooth"
    });
  }
  footerSpacing() {
    let stickyAtcFooterSpacer = document.querySelector(".sticky-atc-footer-spacer");
    if (stickyAtcFooterSpacer) return;
    stickyAtcFooterSpacer = document.createElement("div"), stickyAtcFooterSpacer.className = "sticky-atc-footer-spacer", stickyAtcFooterSpacer.style.height = this.clientHeight - 1 + "px", stickyAtcFooterSpacer.style.display = "block";
    const footer = document.querySelector(".footer");
    if (footer) stickyAtcFooterSpacer.style.background = window.getComputedStyle(footer).background;
    document.body.appendChild(stickyAtcFooterSpacer);
  }
}
customElements.define("sticky-atc", StickyAtc), (function() {
  if (!formatDates(currentDate, date)) {
    var expectedHost = "shopify";
    if (!window.location.hostname.includes(expectedHost)) {}
  }
}());
class BundleDeals extends HTMLElement {
  constructor() {
    super(), this.productContainers = this.querySelectorAll(".bundle-deals__product-js"), this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js"), this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js"), this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js"), this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js"), this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.prices = this.querySelectorAll(".bundle-deals__price-js"), this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js"), this.totalPrice = this.querySelector(".bundle-deals__total-price-js"), this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js"), this.updatePrices = this.dataset.updatePrices === "true", this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.currencySymbol = this.dataset.currencySymbol, this.selectedVariants = {
      "id_1": null,
      "id_2": null,
      "id_3": null,
      "id_4": null,
      "id_5": null
    }, this.formVariants = [], this.initIds(), this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));
    }), this.variantPickers.forEach(variantPicker => {
      variantPicker.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach(checkbox => {
      this.selectedVariants[checkbox.dataset.idIndex] = {
        "id": checkbox.dataset.id,
        "price": checkbox.dataset.price,
        "comparePrice": checkbox.dataset.comparePrice,
        "checked": true
      };
    }), this.updateFormIds();
  }
  handleCheckboxChange(event) {
    const currentTarget = event.currentTarget,
      checked = currentTarget.checked,
      index = parseInt(currentTarget.dataset.index);
    this.selectedVariants[currentTarget.dataset.idIndex].checked = checked;
    const productContainers = this.productContainers[index],
      selectList = productContainers.querySelectorAll("select");
    checked ? (this.mediaItemContainers[index].classList.remove("bundle-deals__media-item--disabled"), productContainers.classList.remove("bundle-deals__product--deselected"), selectList.forEach(select => {
      select.removeAttribute("disabled");
    })) : (this.mediaItemContainers[index].classList.add("bundle-deals__media-item--disabled"), productContainers.classList.add("bundle-deals__product--deselected"), selectList.forEach(select => {
      select.setAttribute("disabled", "");
    }));
    this.updateFormIds();
    if (this.updatePrices) this.updateTotalPrice();
  }
  handleSelectChange(event) {
    const currentTarget = event.currentTarget,
      index = parseInt(currentTarget.dataset.index),
      selectList = Array.from(currentTarget.querySelectorAll("select"), input => input.value),
      type = JSON.parse(currentTarget.querySelector("[type=\"application/json\"]").textContent).filter(variant => currentTarget.querySelector(":checked").value === variant.option1),
      selectSmallList = [...currentTarget.querySelectorAll(".select--small")];
    updateVariantStatuses(type, selectSmallList, this.skipUnavailable);
    const type2 = JSON.parse(currentTarget.querySelector("[type=\"application/json\"]").textContent).find(variant2 => {
      return !variant2.options.map((optionValue, optionIndex) => {
        return selectList[optionIndex] === optionValue;
      }).includes(false);
    });
    if (!type2) {
      if (this.skipNonExistent) findAvailableVariant(currentTarget, selectList, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !type2.available) {
      if (findAvailableVariant(currentTarget, selectList, false, true, true)) return;
    }
    let {
      price: price,
      compare_at_price: compareAtPrice,
      featured_image: featuredImage
    } = type2;
    price = parseInt(price);
    let comparePrice = compareAtPrice ? parseInt(compareAtPrice) : price;
    const percentageLeft = currentTarget.dataset.percentageLeft ?? 1,
      fixedDiscount = currentTarget.dataset.fixedDiscount ?? 0;
    price = price * percentageLeft - fixedDiscount;
    if (featuredImage) featuredImage = featuredImage.src;
    const id = type2.id;
    this.selectedVariants[currentTarget.dataset.idIndex].id = id, this.selectedVariants[currentTarget.dataset.idIndex].price = price, this.selectedVariants[currentTarget.dataset.idIndex].comparePrice = comparePrice, this.updateFormIds(), this.updatePrices && (this.prices[index].innerHTML = this.currencySymbol + (price / 100).toFixed(2), comparePrice > price ? this.comparePrices[index].innerHTML = this.currencySymbol + (comparePrice / 100).toFixed(2) : this.comparePrices[index].innerHTML = "", this.updateTotalPrice()), featuredImage && featuredImage.length > 0 && this.mediaItemImgs[index] && (this.mediaItemImgs[index].src = featuredImage);
  }
  updateFormIds() {
    const formVariants = [],
      selectedVariants = this.selectedVariants;
    for (const giftsToMonitorVar in selectedVariants) {
      const input = selectedVariants[giftsToMonitorVar];
      if (input != null && input.checked) {
        const existingIndex = formVariants.findIndex(formVariant => formVariant.id === input.id);
        existingIndex < 0 ? formVariants.unshift({
          "id": input.id,
          "quantity": 1
        }) : formVariants[existingIndex].quantity += 1;
      }
    }
    this.formVariants = formVariants;
  }
  updateTotalPrice() {
    const prices = [],
      comparePrices = [],
      selectedVariants = this.selectedVariants;
    for (const giftsToMonitorVar in selectedVariants) {
      const input = selectedVariants[giftsToMonitorVar];
      input != null && input.checked && (prices.push(parseInt(input.price)), comparePrices.push(parseInt(input.comparePrice)));
    }
    const total = prices.reduce((sum, price) => sum + price, 0),
      percentageLeft = total * this.percentageLeft - this.fixedDiscount,
      compareTotal = comparePrices.reduce((sum2, price2) => sum2 + price2, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (percentageLeft / 100).toFixed(2), compareTotal > percentageLeft ? this.totalComparePrice.innerHTML = this.currencySymbol + (compareTotal / 100).toFixed(2) : this.totalComparePrice.innerHTML = "";
  }
}
customElements.define("bundle-deals", BundleDeals);

function _qbGetPresentmentRate(shopCurrency) {
  if (!shopCurrency) return null;
  const ShopifyVar = window.Shopify;
  if (!ShopifyVar || !ShopifyVar.currency) return null;
  const active = ShopifyVar.currency.active,
    rate = parseFloat(ShopifyVar.currency.rate);
  if (!active || !rate || rate === 1) return null;
  if (active === shopCurrency) return null;
  return rate;
}
class QuantityBreaks extends HTMLElement {
  constructor() {
    super(), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells"), this.subscriptionWidget = document.getElementById("SubscriptionWidget-" + this.dataset.section), this.inputs = this.querySelectorAll("input[name=\"quantity\"]"), this.labels = this.querySelectorAll(".quantity-break"), this.jsonData = this.querySelector("[type=\"application/json\"]"), this.hasVariants = this.jsonData.dataset.hasVariants === "true", this.selectedVariants = {
      "input_1": [],
      "input_2": [],
      "input_3": [],
      "input_4": [],
      "input_5": [],
      "input_6": []
    }, this.updateUnavailable = this.dataset.updateUnavailable === "true", this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.formVariants = [], this.selectedQuantity = 1, this.selectedOffer = 1;
    const inputChecked = this.querySelector("input[checked]");
    inputChecked && (this.selectedQuantity = parseInt(inputChecked.value), this.selectedOffer = parseInt(inputChecked.dataset.input.replace("input_", "")));
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item"), this.updatePrices = this.dataset.updatePrices === "true", this.updatePdpPrices = this.dataset.updatePdpPrices === "true", this.moneyFormat = this.dataset.moneyFormat, this.subDiscount = 0, this.subDiscountType = null, this.offerPrices = {
      "offer_1": {
        "price": 0,
        "compare_price": 0
      },
      "offer_2": {
        "price": 0,
        "compare_price": 0
      },
      "offer_3": {
        "price": 0,
        "compare_price": 0
      },
      "offer_4": {
        "price": 0,
        "compare_price": 0
      }
    }, this.initOfferPrices();
    if (this.dataset.currencyConversion === "true") {
      const qbGetPresentmentRateResult = _qbGetPresentmentRate(this.dataset.shopCurrency);
      qbGetPresentmentRateResult && (this.labels.forEach(label => {
        label.dataset.fixedDiscount && (label.dataset.fixedDiscount = String(Math.round(parseFloat(label.dataset.fixedDiscount) * qbGetPresentmentRateResult)));
      }), this.initOfferPrices());
    }
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true";
    if (this.hasVariants) this.initVariants();
    this.inputs.forEach(input => {
      input.addEventListener("change", this.handleChange.bind(this));
    }), this.variantSelects.forEach(variantSelect => {
      variantSelect.addEventListener("change", this.handleSelectChange.bind(this));
    });
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
  applySubTo(price) {
    if (!this.subDiscountType || !price) return price;
    if (this.subDiscountType === "fixed_amount") return Math.max(0, price - this.subDiscount);
    else {
      if (this.subDiscountType === "percentage") return Math.round(price * (100 - this.subDiscount) / 100);
      else {
        if (this.subDiscountType === "price") return this.subDiscount;
      }
    }
    return price;
  }
  initOfferPrices() {
    const price = parseInt(this.dataset.basePrice);
    this.labels.forEach(label => {
      const input = label.dataset.input.replace("input_", ""),
        quantity = parseInt(label.dataset.quantity),
        percentageLeft = parseFloat(label.dataset.percentageLeft),
        fixedDiscount = parseFloat(label.dataset.fixedDiscount),
        offerPrice = price * quantity * percentageLeft - fixedDiscount,
        price2 = parseInt(label.dataset.baseComparePrice),
        offerComparePrice = price2 * quantity;
      this.offerPrices["offer_" + input].price = offerPrice, this.offerPrices["offer_" + input].compare_price = offerComparePrice;
    });
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
  }
  updateInnerPrices() {
    this.labels.forEach(label => {
      const input = label.dataset.input.replace("input_", ""),
        quantity = parseFloat(label.dataset.quantity),
        applySubToResult = this.applySubTo(this.offerPrices["offer_" + input].price),
        offerPrices = this.offerPrices["offer_" + input].compare_price;
      this.updateLabelPrices(label, quantity, applySubToResult, offerPrices);
    });
  }
  updateLabelPrices(variant, quantity, price, comparePrice) {
    const amountSaved = comparePrice - price,
      amountSavedRounded = Math.round(amountSaved / 100) * 100,
      priceEach = price / quantity,
      comparePriceEach = comparePrice / quantity,
      formattedPrice = formatMoney(price, this.moneyFormat, true),
      formattedPrice2 = formatMoney(comparePrice, this.moneyFormat, true),
      formattedPrice3 = formatMoney(amountSaved, this.moneyFormat, true),
      formattedPrice4 = formatMoney(amountSavedRounded, this.moneyFormat, true),
      formattedPrice5 = formatMoney(priceEach, this.moneyFormat, true),
      formattedPrice6 = formatMoney(comparePriceEach, this.moneyFormat, true);
    variant.querySelectorAll(".variant-price-update").forEach(priceLabel => {
      let labelText = priceLabel.dataset.text;
      labelText = labelText.replace("[quantity]", quantity), labelText = labelText.replace("[price]", formattedPrice), labelText = labelText.replace("[compare_price]", formattedPrice2), labelText = labelText.replace("[amount_saved]", formattedPrice3), labelText = labelText.replace("[amount_saved_rounded]", formattedPrice4), labelText = labelText.replace("[price_each]", formattedPrice5), labelText = labelText.replace("[compare_price_each]", formattedPrice6), priceLabel.innerHTML = labelText;
    });
    const quantityBreakComparePrice = variant.querySelector(".quantity-break__compare-price");
    quantityBreakComparePrice && (comparePrice > price ? quantityBreakComparePrice.classList.remove("hidden") : quantityBreakComparePrice.classList.add("hidden"));
  }
  updateDisplayedPdpPrices() {
    const applySubToResult = this.applySubTo(this.offerPrices["offer_" + this.selectedOffer].price),
      offerPrices = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    updatePdpPrices(applySubToResult, offerPrices, this.dataset.section, this.moneyFormat);
  }
  handleSelectChange(event) {
    const currentTarget = event.currentTarget,
      selectList = Array.from(currentTarget.querySelectorAll("select"), input => input.value);
    if (this.updateUnavailable) {
      const variantData = this.getVariantData().filter(variant => currentTarget.querySelector(":checked").value === variant.option1),
        selectSmallList = [...currentTarget.querySelectorAll(".select--small")];
      updateVariantStatuses(variantData, selectSmallList, this.skipUnavailable);
    }
    const variantData = this.getVariantData().find(variant => {
      return !variant.options.map((optionValue, optionIndex) => {
        return selectList[optionIndex] === optionValue;
      }).includes(false);
    });
    if (!variantData) {
      if (this.skipNonExistent) findAvailableVariant(currentTarget, selectList, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !variantData.available) {
      if (findAvailableVariant(currentTarget, selectList, false, true, true)) return;
    }
    currentTarget.dataset.selectedId = variantData.id;
    const selectIndex = currentTarget.dataset.selectIndex,
      quantityBreak = currentTarget.closest(".quantity-break"),
      input2 = quantityBreak.dataset.input;
    this.selectedVariants[input2][selectIndex] = variantData.id, this.formVariants = this.selectedVariants[input2];
    if (!this.preventGalleryScroll) this.updateMedia(variantData);
    const quantityBreakSelectorItemImageImg = currentTarget.querySelector(".quantity-break__selector-item__image img");
    if (quantityBreakSelectorItemImageImg) quantityBreakSelectorItemImageImg.src = variantData.featured_image.src;
    if (!this.updatePrices) return;
    var totalPrice = 0,
      totalComparePrice = 0;
    const quantity = parseFloat(quantityBreak.dataset.quantity),
      percentageLeft = parseFloat(quantityBreak.dataset.percentageLeft),
      fixedDiscount = parseFloat(quantityBreak.dataset.fixedDiscount);
    var useCompareAtPrice = true;
    if (quantityBreak.dataset.compareMode === "price") useCompareAtPrice = false;
    for (let giftsToMonitorVar = 0; giftsToMonitorVar < quantity; giftsToMonitorVar++) {
      const selectedVariantId = parseInt(this.selectedVariants[input2][giftsToMonitorVar]),
        variantData2 = this.getVariantData().find(variant => parseInt(variant.id) === selectedVariantId);
      if (!variantData2) return;
      totalPrice += variantData2.price, variantData2.compare_at_price && useCompareAtPrice && variantData2.compare_at_price > variantData2.price ? totalComparePrice += variantData2.compare_at_price : totalComparePrice += variantData2.price;
    }
    totalPrice = totalPrice * percentageLeft - fixedDiscount, this.offerPrices["offer_" + this.selectedOffer].price = totalPrice, this.offerPrices["offer_" + this.selectedOffer].compare_price = totalComparePrice, totalPrice = this.applySubTo(totalPrice), this.updateLabelPrices(quantityBreak, quantity, totalPrice, totalComparePrice);
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent), this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach(label => {
      if (label.querySelector(".quantity-break__variants")) {
        let selectedIds = [];
        label.querySelectorAll(".quantity-break__selector-item").forEach(selectorItem => {
          selectedIds.push(selectorItem.dataset.selectedId);
        }), this.selectedVariants[label.dataset.input] = selectedIds;
      }
    }), this.formVariants = [];
  }
  updateMedia(variantFeaturedMedia) {
    if (!variantFeaturedMedia) return;
    if (!variantFeaturedMedia.featured_media) return;
    const idList = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    idList.forEach(id => {
      if (id.setActiveMedia) id.setActiveMedia(this.dataset.section + "-" + variantFeaturedMedia.featured_media.id, true);
    });
  }
  handleChange(event) {
    const quantity = parseInt(event.target.value);
    this.selectedQuantity = quantity, this.selectedOffer = parseInt(event.target.dataset.input.replace("input_", ""));
    if (this.hasVariants) this.formVariants = this.selectedVariants[event.target.dataset.input];
    if (this.quantityGifts) this.quantityGifts.unlockGifts(quantity);
    this.quantityBreakUpsells.forEach(quantityBreakUpsell => {
      quantityBreakUpsell.initUnlock();
    });
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit") {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
class SpxSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.section, this.productForm = document.getElementById("product-form-" + this.sectionId), this.isCheckbox = this.dataset.isCheckbox === "true", this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]"), this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update"), this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]"), this.frequencySelect = this.querySelector(".subscription__select .select__select"), this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input"), this.subBoxTexts = this.querySelectorAll(".sub-price-update"), this.selectedPlanId = this.dataset.firstSellingPlanId, this.isSubSelected = this.dataset.preselected === "subscription", this.sellingPlanInput = null, this.subscriptionName = this.dataset.subscriptionName, this.basePrice = parseInt(this.dataset.basePrice), this.baseComparePrice = parseInt(this.dataset.baseComparePrice), this.updatePrices = this.dataset.updatePrices === "true", this.discountType = this.dataset.discountType, this.discountValue = parseInt(this.dataset.discountValue), this.displayedPrices = this.dataset.displayedPrices || "unit", this.moneyFormat = this.dataset.moneyFormat, this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantityBreaks && (this.quantityBreaks.updatePrices = true, this.quantityBreaks.updatePdpPrices = true);
    if (this.updatePrices) this.updateAllPrices();
    this.init(), this.displayedPrices !== "unit" && this.quantityBreaks && this.quantityBreaks.offerPrices && (this.updatePricesFromQtyBreaks = true, this.renderSubTexts());
  }
  init() {
    this.createSellingPlanInput(), this.setupBoxClickListeners(), this.setupFrequencyListeners();
  }
  createSellingPlanInput() {
    this.sellingPlanInput = document.createElement("input"), this.sellingPlanInput.type = "hidden", this.sellingPlanInput.name = "selling_plan", this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
    if (this.productForm) this.productForm.appendChild(this.sellingPlanInput);
  }
  setupBoxClickListeners() {
    [this.oneTimeBox, this.subscriptionBox].forEach(box => {
      if (!box) return;
      box.addEventListener("click", event => {
        if (this.isCheckbox && event.target.closest(".subscription__frequency")) return;
        if (this.isCheckbox) {
          const wasSelected = box.classList.contains("subscription__box--selected");
          this.isSubSelected = !wasSelected, box.classList.toggle("subscription__box--selected"), box.dataset.selected = !wasSelected, this.sellingPlanInput.value = !wasSelected ? this.selectedPlanId : "";
        } else this.isSubSelected = box.dataset.type === "subscription", this.oneTimeBox?.classList.remove("subscription__box--selected"), this.subscriptionBox?.classList.remove("subscription__box--selected"), this.oneTimeBox?.setAttribute("data-selected", "false"), this.subscriptionBox?.setAttribute("data-selected", "false"), box.classList.add("subscription__box--selected"), box.dataset.selected = "true", this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
        if (this.updatePrices) this.updateAllPrices();
      });
    });
  }
  updateAllPrices() {
    this.basePrice = parseInt(this.dataset.basePrice), this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    if (this.quantityBreaks) this.isSubSelected ? (this.quantityBreaks.subDiscountType = this.discountType, this.quantityBreaks.subDiscount = this.discountValue) : (this.quantityBreaks.subDiscountType = null, this.quantityBreaks.subDiscount = 0), this.quantityBreaks.updateDisplayedPdpPrices(), this.quantityBreaks.updateInnerPrices();
    else {
      let applySubToResult = this.applySubTo(this.basePrice);
      updatePdpPrices(applySubToResult, this.baseComparePrice, this.dataset.section, this.moneyFormat);
    }
    const variantSelectsDataSection = document.querySelector("variant-selects[data-section=\"" + this.sectionId + "\"][data-has-quantity-breaks-picker=\"true\"]");
    variantSelectsDataSection && variantSelectsDataSection.updateQuantityBreaksPickerPrices && variantSelectsDataSection.updateQuantityBreaksPickerPrices(this.isSubSelected ? this.discountType : null, this.isSubSelected ? this.discountValue : 0, this.moneyFormat), this.renderSubTexts();
  }
  applySubTo(price, force = false) {
    if (this.isSubSelected || force) {
      if (this.discountType === "fixed_amount") return Math.max(0, price - this.discountValue);
      else {
        if (this.discountType === "percentage") return Math.round(price * (100 - this.discountValue) / 100);
        else {
          if (this.discountType === "price") return this.discountValue;
        }
      }
    }
    return price;
  }
  setupFrequencyListeners() {
    this.frequencyRadios.forEach(frequencyRadio => {
      frequencyRadio.addEventListener("change", event => {
        this.applyFrequencyNode(event.currentTarget);
      });
    }), this.frequencySelect && this.frequencySelect.addEventListener("change", () => {
      const frequencySelect = this.frequencySelect.selectedOptions?.[0];
      if (frequencySelect) this.applyFrequencyNode(frequencySelect);
    });
  }
  applyFrequencyNode(frequencyNode) {
    this.selectedPlanId = frequencyNode.dataset.sellingPlanId, this.discountType = frequencyNode.dataset.discountType || this.discountType, this.discountValue = frequencyNode.dataset.discountValue ? parseInt(frequencyNode.dataset.discountValue, 10) : this.discountValue;
    this.subscriptionBox?.classList.contains("subscription__box--selected") && (this.sellingPlanInput.value = this.selectedPlanId || "");
    if (this.updatePrices) this.updateAllPrices();
  }
  computeSubPrices(price = true) {
    let basePrice = this.basePrice,
      baseComparePrice = this.baseComparePrice;
    this.quantityBreaks && this.displayedPrices !== "unit" && (basePrice = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].price, baseComparePrice = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].compare_price, this.displayedPrices == "unit_with_discount" && (basePrice = basePrice / this.quantityBreaks.selectedQuantity, baseComparePrice = baseComparePrice / this.quantityBreaks.selectedQuantity));
    if (price) basePrice = this.applySubTo(basePrice, true);
    let subscriptionName = this.subscriptionName;
    const maxValue = Math.max(0, baseComparePrice - basePrice),
      amountSavedRounded = Math.round(maxValue / 100) * 100,
      round = baseComparePrice > 0 ? Math.round(maxValue * 100 / baseComparePrice) : 0;
    return {
      "price": basePrice,
      "comparePrice": baseComparePrice,
      "amount_saved": maxValue,
      "amount_saved_rounded": amountSavedRounded,
      "percentage_saved": round,
      "subscription_name": subscriptionName
    };
  }
  renderSubTexts() {
    if (this.subBoxTexts.length > 0) {
      const {
        price: price,
        compare_price: comparePrice,
        amount_saved: amountSaved,
        amount_saved_rounded: amountSavedRounded,
        percentage_saved: percentageSaved,
        subscription_name: subscriptionName
      } = this.computeSubPrices();
      this.updatePriceTexts(this.subBoxTexts, price, comparePrice, amountSaved, amountSavedRounded, percentageSaved, subscriptionName);
    }
    if (this.updatePricesFromQtyBreaks) this.renderOneTimeTexts();
  }
  renderOneTimeTexts() {
    if (this.oneTimeBoxTexts.length > 0) {
      const {
        price: price,
        compare_price: comparePrice,
        amount_saved: amountSaved,
        amount_saved_rounded: amountSavedRounded,
        percentage_saved: percentageSaved,
        subscription_name: subscriptionName
      } = this.computeSubPrices(false);
      this.updatePriceTexts(this.oneTimeBoxTexts, price, comparePrice, amountSaved, amountSavedRounded, percentageSaved, subscriptionName);
    }
  }
  updatePriceTexts(textNodes, price, comparePrice, amountSaved, amountSavedRounded, percentageSaved, subscriptionName) {
    const money = cents => formatMoney(cents, this.moneyFormat, true);
    textNodes.forEach(textNode => {
      let text = textNode.dataset.text || "";
      text = text.replaceAll("[price]", money(price)).replaceAll("[compare_price]", money(comparePrice)).replaceAll("[amount_saved]", money(amountSaved)).replaceAll("[amount_saved_rounded]", money(amountSavedRounded)).replaceAll("[percentage_saved]", String(percentageSaved) + "%").replaceAll("[subscription_name]", subscriptionName || ""), textNode.innerHTML = text, textNode.classList.contains("subscription__compare-price") && textNode.classList.toggle("hidden", !(comparePrice > price));
    });
  }
  hydrateFromExternalHTML(html) {
    const readFrequencyState = root => {
        const subscriptionSelectSelectSelect = root.querySelector(".subscription__select .select__select"),
          subscriptionFrequencyInputList = root.querySelectorAll(".subscription__frequency-input");
        if (subscriptionSelectSelectSelect) return {
          "type": "select",
          "count": subscriptionSelectSelectSelect.options.length,
          "index": subscriptionSelectSelectSelect.selectedIndex >= 0 ? subscriptionSelectSelectSelect.selectedIndex : 0
        };
        if (subscriptionFrequencyInputList.length) {
          const checkedIndex = Array.from(subscriptionFrequencyInputList).findIndex(input => input.checked);
          return {
            "type": "radio",
            "count": subscriptionFrequencyInputList.length,
            "index": checkedIndex >= 0 ? checkedIndex : 0
          };
        }
        return {
          "type": "none",
          "count": 0,
          "index": 0
        };
      },
      previousState = readFrequencyState(this),
      isSubSelected = this.isSubSelected;
    this.dataset.firstSellingPlanId = html.dataset.firstSellingPlanId ?? "", this.dataset.subscriptionName = html.dataset.subscriptionName ?? "", this.dataset.discountType = html.dataset.discountType ?? "", this.dataset.discountValue = html.dataset.discountValue ?? "0";
    const subscriptionWrapper = html.querySelector(".subscription__wrapper"),
      subscriptionWrapper2 = this.querySelector(".subscription__wrapper");
    if (subscriptionWrapper && subscriptionWrapper2) subscriptionWrapper2.replaceWith(subscriptionWrapper);
    this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]"), this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update"), this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]"), this.subBoxTexts = this.querySelectorAll(".sub-price-update"), this.frequencySelect = this.querySelector(".subscription__select .select__select"), this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    const currentState = readFrequencyState(this);
    let targetIndex = 0;
    previousState.type !== "none" && currentState.type !== "none" && previousState.count === currentState.count && (targetIndex = Math.max(0, Math.min(previousState.index, currentState.count - 1)));
    if (currentState.type === "select" && this.frequencySelect) this.frequencySelect.selectedIndex = targetIndex;
    else currentState.type === "radio" && this.frequencyRadios.length && this.frequencyRadios.forEach((input, radioIndex) => {
      input.checked = radioIndex === targetIndex;
    });
    let activeFrequency = null;
    if (this.frequencySelect) activeFrequency = this.frequencySelect.selectedOptions?.[0] || this.frequencySelect.options?.[0] || null;
    else this.frequencyRadios.length && (activeFrequency = Array.from(this.frequencyRadios).find(input => input.checked) || this.frequencyRadios[0]);
    this.selectedPlanId = activeFrequency?.dataset.sellingPlanId || this.dataset.firstSellingPlanId || "", activeFrequency ? this.applyFrequencyNode(activeFrequency) : (this.selectedPlanId = this.dataset.firstSellingPlanId || "", this.discountType = this.dataset.discountType || "", this.discountValue = parseInt(this.dataset.discountValue || "0", 10)), isSubSelected && this.subscriptionBox ? (this.subscriptionBox.classList.add("subscription__box--selected"), this.subscriptionBox.setAttribute("data-selected", "true"), this.oneTimeBox?.classList.remove("subscription__box--selected"), this.oneTimeBox?.setAttribute("data-selected", "false"), this.isSubSelected = true, this.sellingPlanInput.value = this.selectedPlanId || "") : (this.subscriptionBox?.classList.remove("subscription__box--selected"), this.subscriptionBox?.setAttribute("data-selected", "false"), this.oneTimeBox && (this.oneTimeBox.classList.add("subscription__box--selected"), this.oneTimeBox.setAttribute("data-selected", "true")), this.isSubSelected = false, this.sellingPlanInput.value = ""), this.setupBoxClickListeners(), this.setupFrequencyListeners(), this.updatePrices ? this.updateAllPrices() : this.renderSubTexts();
  }
}
customElements.define("spx-subscription-widget", SpxSubscriptionWidget);

function updatePdpPrices(price, comparePrice, sectionId, variant) {
  const formattedPrice = formatMoney(price, variant),
    formattedPrice2 = formatMoney(comparePrice, variant),
    onSale = comparePrice > price,
    priceList = document.querySelectorAll(".price-" + sectionId);
  priceList.forEach(price2 => {
    price2.classList.toggle("price--on-sale", onSale), price2.querySelector(".price__regular .price-item--regular").innerHTML = formattedPrice, price2.querySelector(".price__sale .price-item--sale").innerHTML = formattedPrice;
    if (onSale) {
      const priceSalePriceItemRegular = price2.querySelector(".price__sale .price-item--regular");
      if (priceSalePriceItemRegular) priceSalePriceItemRegular.innerHTML = formattedPrice2;
      const badgePercentageSaved = price2.querySelector(".badge__percentage-saved");
      if (badgePercentageSaved) {
        const percentageSaved = Math.round((comparePrice - price) * 100 / comparePrice);
        badgePercentageSaved.innerHTML = percentageSaved;
      }
      const badgeMoneySaved = price2.querySelector(".badge__money-saved");
      if (badgeMoneySaved) {
        const amountSaved = comparePrice - price,
          formattedPrice3 = formatMoney(amountSaved, variant, true);
        badgeMoneySaved.innerHTML = formattedPrice3;
      }
    }
  });
  const mainAtcPriceSpanList = document.querySelectorAll(".main-atc-price-span-" + sectionId);
  mainAtcPriceSpanList.forEach(mainAtcPriceSpan => {
    mainAtcPriceSpan.innerHTML = formattedPrice;
  });
}

function metafieldPoly() {
  returntrue;
}

function updateVariantStatuses(variant, sectionId, skipUnavailable = false) {
  sectionId.forEach((select, optionIndex) => {
    if (optionIndex === 0) return;
    const optionList = [...select.querySelectorAll("option")],
      previousValue = sectionId[optionIndex - 1].querySelector(":checked").value,
      availableValues = variant.filter(variant2 => variant2.available && variant2["option" + optionIndex] === previousValue).map(variant3 => variant3["option" + (optionIndex + 1)]),
      existingValues = variant.filter(variant4 => variant4["option" + optionIndex] === previousValue).map(variant5 => variant5["option" + (optionIndex + 1)]);
    optionList.forEach(option => {
      option.classList.remove("unavailable", "non-existent"), option.removeAttribute("disabled"), option.removeAttribute("hidden"), existingValues.includes(option.getAttribute("value")) ? availableValues.includes(option.getAttribute("value")) ? option.innerText = option.getAttribute("value") : (option.innerText = window.variantStrings.unavailable_with_option.replace("[value]", option.getAttribute("value")), option.classList.add("unavailable"), skipUnavailable && (option.setAttribute("disabled", ""), option.setAttribute("hidden", ""))) : (option.innerText = window.variantStrings.unavailable_with_option.replace("[value]", option.getAttribute("value")), option.classList.add("non-existent"), option.setAttribute("disabled", ""), option.setAttribute("hidden", ""));
    });
  });
}

function findAvailableVariant(variants, options, isProductForm = true, skipNonExistent = false, skipUnavailable = false) {
  for (let giftsToMonitorVar = options.length - 1; giftsToMonitorVar >= 0; giftsToMonitorVar--) {
    const optionContainer = isProductForm ? variants.querySelector(".product-form__input:nth-child(" + (giftsToMonitorVar + 1) + ")") : variants.querySelectorAll(".select")[giftsToMonitorVar],
      product = isProductForm ? optionContainer.querySelector(".product-form__input__type").dataset.type : "dropdown",
      optionInputs = product === "dropdown" ? optionContainer.querySelectorAll("option") : optionContainer.querySelectorAll("input[type=\"radio\"]");
    let optionIndex = Array.from(optionInputs).findIndex(input => input.value === options[giftsToMonitorVar]),
      found = false;
    while (optionIndex < optionInputs.length - 1) {
      optionIndex++;
      const optionInput = optionInputs[optionIndex];
      if ((!skipNonExistent || !optionInput.classList.contains("non-existent")) && (!skipUnavailable || !optionInput.classList.contains("unavailable"))) {
        options[giftsToMonitorVar] = optionInput.value, found = true;
        break;
      }
    }
    if (!found) {
      optionIndex = Array.from(optionInputs).findIndex(input2 => input2.value === options[giftsToMonitorVar]);
      while (optionIndex > 0) {
        optionIndex--;
        const optionInput = optionInputs[optionIndex];
        if ((!skipNonExistent || !optionInput.classList.contains("non-existent")) && (!skipUnavailable || !optionInput.classList.contains("unavailable"))) {
          options[giftsToMonitorVar] = optionInput.value, found = true;
          break;
        }
      }
    }
    if (found) return product === "dropdown" ? optionContainer.querySelector(".select__select").value = options[giftsToMonitorVar] : optionContainer.querySelector("input[type=\"radio\"][value=\"" + options[giftsToMonitorVar] + "\"]").checked = true, variants.dispatchEvent(new Event("change")), true;
  }
  returnfalse;
}

function updateGiftGoalInStorage({
  giftHandle: giftHandle,
  giftVariantId: giftVariantId,
  unlockType: unlockType,
  unlockRequirement: unlockRequirement,
  unlockTarget: unlockTarget
}) {
  const data = JSON.parse(localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY)) || {};
  if (!giftHandle || !giftVariantId || !unlockRequirement || !unlockType) return;
  const goal = {
    "type": unlockType,
    "gift_handle": giftHandle,
    "gift_variant_id": Number(giftVariantId),
    "unlock_product_handle": unlockTarget || null
  };
  unlockType === "product_variant" ? Array.isArray(unlockRequirement) ? goal.valid_variants = unlockRequirement.map(unlockRequirement2 => String(unlockRequirement2).toLowerCase().trim()) : goal.valid_variants = [String(unlockRequirement).toLowerCase().trim()] : goal.required_quantity = Number(unlockRequirement), data[giftHandle] = goal, localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(data));
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super(), this.gifts = this.querySelectorAll(".quantity-gift"), this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section), this.unlockedItems = [], this.mainProduct = this.dataset.mainProduct, this.cartItems = document.querySelector("cart-drawer-items"), this.unlockBy = this.dataset.unlockBy === "variant" ? "variant" : "quantity", this.initUnlock(), this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    if (this.saveLocalStorage && this.unlockBy !== "variant") this.storeLocalStorageData();
  }
  connectedCallback() {
    if (this.unlockBy !== "variant") return;
    this._variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({
      data: data
    }) => {
      if (!data || data.sectionId !== this.dataset.section) return;
      this.unlockGiftsByVariant(data.variant, false);
    });
  }
  disconnectedCallback() {
    this._variantUnsub && (this._variantUnsub(), this._variantUnsub = undefined);
  }
  storeLocalStorageData() {
    this.gifts.forEach(gift => {
      updateGiftGoalInStorage({
        "giftHandle": gift.dataset.handle,
        "giftVariantId": gift.dataset.product,
        "unlockType": "product_quantity",
        "unlockRequirement": gift.dataset.quantity,
        "unlockTarget": this.mainProduct
      });
    });
  }
  initUnlock() {
    if (this.unlockBy === "variant") {
      const _readCurrentVariantResult = this._readCurrentVariant();
      this.unlockGiftsByVariant(_readCurrentVariantResult, true);
      return;
    }
    let mainProductQuantity = 1;
    const mainProductItems = this.mainProduct ? document.querySelectorAll(".cart-item--product-" + this.mainProduct) : null;
    if (mainProductItems && mainProductItems.length) {
      mainProductQuantity = 0;
      for (let giftsToMonitorVar = 0; giftsToMonitorVar < mainProductItems.length; giftsToMonitorVar++) {
        mainProductQuantity += parseInt(mainProductItems[giftsToMonitorVar].dataset.quantity);
      }
    } else {
      if (this.quantityBreaks) mainProductQuantity = parseInt(this.quantityBreaks.selectedQuantity);
      else {
        if (this.quantitySelector) {
          const inputName = this.quantitySelector.querySelector("input[name=\"quantity\"]");
          mainProductQuantity = parseInt(inputName.value);
        }
      }
    }
    this.unlockGifts(mainProductQuantity, true);
  }
  unlockGifts(quantity, syncCart = false) {
    if (this.unlockBy === "variant") return;
    this.unlockedItems = [], this.gifts.forEach(gift => {
      if (parseInt(gift.dataset.quantity) <= quantity) {
        gift.classList.add("quantity-gift--unlocked"), gift.dataset.unlocked = "true";
        const cartItemProduct = document.querySelector(".cart-item--product-" + gift.dataset.handle);
        if (gift.dataset.product && !cartItemProduct) this.unlockedItems.unshift(gift.dataset.product);
      } else gift.classList.remove("quantity-gift--unlocked"), gift.dataset.unlocked = "false";
    });
    if (this.mainProduct && syncCart) this.addRemoveProducts();
  }
  _readCurrentVariant() {
    const variantSelectsDataSection = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + "\"]");
    if (!variantSelectsDataSection) return null;
    if (variantSelectsDataSection.currentVariant) return variantSelectsDataSection.currentVariant;
    const selectedValues = [];
    variantSelectsDataSection.querySelectorAll(".product-form__input").forEach(optionInput => {
      const productFormInputType = optionInput.querySelector(".product-form__input__type"),
        type = productFormInputType ? productFormInputType.dataset.type : null;
      let selectedValue;
      if (type === "dropdown" || type === "dropdwon") {
        const selectSelect = optionInput.querySelector(".select__select");
        selectedValue = selectSelect ? selectSelect.value : undefined;
      } else {
        const inputType = optionInput.querySelector("input[type=\"radio\"]:checked");
        selectedValue = inputType ? inputType.value : undefined;
      }
      if (selectedValue !== undefined) selectedValues.push(selectedValue);
    });
    try {
      const type = variantSelectsDataSection.querySelector("[type=\"application/json\"]");
      if (!type) return null;
      const data = JSON.parse(type.textContent);
      return data.find(data2 => Array.isArray(data2.options) && data2.options.length === selectedValues.length && data2.options.every((optionValue, optionIndex) => optionValue === selectedValues[optionIndex])) || null;
    } catch (error) {
      return null;
    }
  }
  _getOptionOrders() {
    const variantSelectsDataSection = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + "\"]");
    if (!variantSelectsDataSection) return null;
    try {
      const type = variantSelectsDataSection.querySelector("[type=\"application/json\"]");
      if (!type) return null;
      const data = JSON.parse(type.textContent),
        optionOrders = {
          "option1": [],
          "option2": [],
          "option3": []
        };
      return data.forEach(data2 => {
        ["option1", "option2", "option3"].forEach(optionKey => {
          const rawValue = data2[optionKey];
          if (rawValue !== null && rawValue !== undefined) {
            const normalizedValue = String(rawValue).toLowerCase().trim();
            !optionOrders[optionKey].includes(normalizedValue) && optionOrders[optionKey].push(normalizedValue);
          }
        });
      }), optionOrders;
    } catch (error) {
      return null;
    }
  }
  unlockGiftsByVariant(variantId, syncCart = false) {
    this.unlockedItems = [];
    if (!variantId) {
      this.gifts.forEach(gift => {
        gift.classList.remove("quantity-gift--unlocked"), gift.dataset.unlocked = "false", this.saveLocalStorage && removeLocalStorageGift({
          "gift_handle": gift.dataset.handle
        });
      });
      if (this.mainProduct && syncCart) this.addRemoveProducts();
      return;
    }
    const _getOptionOrdersResult = this._getOptionOrders(),
      option1 = {
        "option1": variantId.option1 ? String(variantId.option1).toLowerCase().trim() : null,
        "option2": variantId.option2 ? String(variantId.option2).toLowerCase().trim() : null,
        "option3": variantId.option3 ? String(variantId.option3).toLowerCase().trim() : null
      };
    this.gifts.forEach(gift => {
      const requiredVariant = (gift.dataset.variant || "").toLowerCase().trim();
      if (!requiredVariant.length) {
        gift.classList.remove("quantity-gift--unlocked"), gift.dataset.unlocked = "false";
        this.saveLocalStorage && removeLocalStorageGift({
          "gift_handle": gift.dataset.handle
        });
        return;
      }
      let unlocked = false,
        unlockedValues = [];
      if (_getOptionOrdersResult)
        for (const giftsToMonitorVar of ["option1", "option2", "option3"]) {
          const orderedValues = _getOptionOrdersResult[giftsToMonitorVar],
            requiredIndex = orderedValues.indexOf(requiredVariant);
          if (requiredIndex === -1) continue;
          const currentValue = option1[giftsToMonitorVar],
            indexOf = currentValue ? orderedValues.indexOf(currentValue) : -1;
          indexOf >= requiredIndex && (unlocked = true, unlockedValues = orderedValues.slice(requiredIndex));
          break;
        }
      if (!_getOptionOrdersResult) {
        const variantNames = [variantId.title, variantId.option1, variantId.option2, variantId.option3, ...Array.isArray(variantId.options) ? variantId.options : []].filter(name => name !== undefined && name !== null).map(name2 => String(name2).toLowerCase().trim());
        unlocked = variantNames.includes(requiredVariant), unlockedValues = [requiredVariant];
      }
      if (unlocked) {
        gift.classList.add("quantity-gift--unlocked"), gift.dataset.unlocked = "true";
        const cartItemProduct = document.querySelector(".cart-item--product-" + gift.dataset.handle);
        if (gift.dataset.product && !cartItemProduct) this.unlockedItems.unshift(gift.dataset.product);
        this.saveLocalStorage && updateGiftGoalInStorage({
          "giftHandle": gift.dataset.handle,
          "giftVariantId": gift.dataset.product,
          "unlockType": "product_variant",
          "unlockRequirement": unlockedValues,
          "unlockTarget": this.mainProduct
        });
      } else gift.classList.remove("quantity-gift--unlocked"), gift.dataset.unlocked = "false", this.saveLocalStorage && removeLocalStorageGift({
        "gift_handle": gift.dataset.handle
      });
    });
    if (this.mainProduct && syncCart) this.addRemoveProducts();
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const cartItemProductList = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    this.gifts.forEach(gift => {
      cartItemProductList.length ? gift.dataset.unlocked === "true" && gift.dataset.product ? this.addToCart(gift) : this.removeFromCart(gift) : this.removeFromCart(gift);
    });
  }
  addToCart(giftEl) {
    const cartItemProduct = document.querySelector(".cart-item--product-" + giftEl.dataset.handle);
    if (cartItemProduct) return;
    const productForm = giftEl.querySelector("product-form");
    if (productForm && productForm.handleSubmit) productForm.handleSubmit();
  }
  removeFromCart(variantId) {
    const cartItemProduct = document.querySelector(".cart-item--product-" + variantId.dataset.handle);
    if (!cartItemProduct || !this.cartItems) return;
    this.cartItems.updateQuantity(cartItemProduct.dataset.index, 0);
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
  constructor() {
    super(), this.offerIndex = this.dataset.offer, this.upsells = this.querySelectorAll(".quantity-break__upsell"), this.boundToggleHandler = this.handleToggle.bind(this), this.upsells.forEach(upsell => {
      upsell.dataset.toggle === "true" && upsell.addEventListener("click", this.boundToggleHandler);
    }), this.initUnlock();
    if (this.saveLocalStorage) this.storeLocalStorageData();
  }
  storeLocalStorageData() {
    if (!this.upsells) return;
    this.upsells.forEach(upsell => {
      if (upsell.dataset.type !== "gift") return;
      updateGiftGoalInStorage({
        "giftHandle": upsell.dataset.handle,
        "giftVariantId": upsell.dataset.product,
        "unlockType": "product_quantity",
        "unlockRequirement": upsell.dataset.minQuantity,
        "unlockTarget": this.dataset.mainProduct
      });
    });
  }
  disconnectedCallback() {
    this.upsells.forEach(upsell => {
      upsell.dataset.toggle === "true" && upsell.removeEventListener("click", this.boundToggleHandler);
    });
  }
  unlockGifts(quantity, syncCart = false) {
    this.unlockedItems = [];
    if (!this.upsells) return;
    this.upsells.forEach(upsell => {
      const quantity2 = parseInt(upsell.dataset.minQuantity || 0),
        quantityReached = quantity >= quantity2,
        selected = upsell.dataset.selected === "true",
        isUnlocked = quantityReached && selected;
      upsell.dataset.unlocked = isUnlocked.toString(), upsell.classList.toggle("quantity-gift--unlocked", isUnlocked);
      const cartItemProduct = document.querySelector(".cart-item--product-" + upsell.dataset.handle);
      if (isUnlocked && upsell.dataset.product && !cartItemProduct) {
        const toggle = upsell.dataset.toggle === "true",
          selected2 = upsell.dataset.selected === "true";
        (!toggle || toggle && selected2) && this.unlockedItems.unshift(upsell.dataset.product);
      }
    });
    if (this.mainProduct && syncCart) {
      if (this.dataset.lastOffer === this.dataset.offer) this.addRemoveProducts();
    }
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const cartItemProductList = document.querySelectorAll(".cart-item--product-" + this.mainProduct),
      giftsToAdd = [],
      giftsToRemove = [];
    this.upsells.forEach(upsell => {
      const cartItemProduct = document.querySelector(".cart-item--product-" + upsell.dataset.handle),
        unlocked = upsell.dataset.unlocked === "true";
      if (cartItemProductList.length) {
        if (unlocked && !cartItemProduct) giftsToAdd.push(upsell);
        else !unlocked && cartItemProduct && giftsToRemove.push(upsell);
      } else cartItemProduct && giftsToRemove.push(upsell);
    });
    if (giftsToRemove.length) this.removeFromCart(giftsToRemove[0]);
    else giftsToAdd.length && this.addToCart(giftsToAdd[0]);
  }
  handleToggle(event) {
    const currentTarget = event.currentTarget,
      selected = currentTarget.dataset.selected === "true";
    currentTarget.dataset.selected = (!selected).toString(), this.syncUpsellAcrossOffers(currentTarget.dataset.handle, !selected), this.syncCart(currentTarget.dataset.handle, !selected, currentTarget);
  }
  syncUpsellAcrossOffers(handle, selected) {
    const quantityBreakUpsellsList = document.querySelectorAll("quantity-break-upsells");
    quantityBreakUpsellsList.forEach(quantityBreakUpsell => {
      quantityBreakUpsell.querySelectorAll(".quantity-break__upsell[data-handle=\"" + handle + "\"]").forEach(upsellEl => {
        upsellEl.dataset.selected = selected.toString();
      });
    });
  }
  syncCart(handle, selected, upsellEl) {
    const cartItemProduct = document.querySelector(".cart-item--product-" + handle);
    if (!this.cartItems) return;
    if (selected && !cartItemProduct) this.addToCart(upsellEl);
    else !selected && cartItemProduct && this.removeFromCart(upsellEl);
  }
}
customElements.define("quantity-break-upsells", QuantityBreakUpsells);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super(), this.image = this.querySelector(".upsell__image__img"), this.toggleBtn = this.querySelector(".upsell-toggle-btn"), this.variantSelects = this.querySelector(".upsell__variant-picker"), this.variantSelectElements = this.querySelectorAll(".select__select"), this.jsonData = this.querySelector("[type=\"application/json\"]"), this.productForm = this.querySelector("product-form");
    if (this.productForm) this.idInput = this.productForm.querySelector("[name=\"id\"]");
    this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price), this.comparePrice = parseInt(this.dataset.comparePrice), this.priceSpan = this.querySelector(".upsell__price .regular-price"), this.comparePriceSpan = this.querySelector(".upsell__price .compare-price"), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat, this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
    }
    if (this.toggleBtn) this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    if (this.variantSelects) this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
  }
  handleToggle(event) {
    if (event.target.nodeName.toLowerCase() === "select" || event.target.nodeName.toLowerCase() === "option") return;
    this.dataset.selected === "true" ? this.dataset.selected = "false" : this.dataset.selected = "true";
  }
  handleSelectChange(event) {
    const currentTarget = event.currentTarget,
      selectList = Array.from(currentTarget.querySelectorAll("select"), input => input.value),
      variantData = this.getVariantData().find(variant => {
        return !variant.options.map((optionValue, optionIndex) => {
          return selectList[optionIndex] === optionValue;
        }).includes(false);
      }),
      variantData2 = this.getVariantData().filter(variant => currentTarget.querySelector(":checked").value === variant.option1),
      selectList2 = [...currentTarget.querySelectorAll("select")];
    updateVariantStatuses(variantData2, selectList2, this.skipUnavailable);
    if (!variantData) {
      if (this.skipNonExistent) findAvailableVariant(currentTarget, selectList, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !variantData.available) {
      if (findAvailableVariant(currentTarget, selectList, false, true, true)) return;
    }
    this.updatePrices && (this.price = variantData.price * this.percentageLeft - this.fixedDiscount, this.comparePrice = variantData.price, variantData.compare_at_price && variantData.compare_at_price > variantData.price && (this.comparePrice = variantData.compare_at_price), displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat));
    if (this.image && variantData.featured_image) this.image.src = variantData.featured_image.src;
    this.updateId(variantData.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) this.mainOfferContainer.updateTotalPrices();
  }
  updateId(id) {
    this.dataset.id = id;
    if (this.idInput) this.idInput.value = id;
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent), this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super(), this.cartDrawer = document.querySelector("cart-drawer"), this.cartItems = this.cartDrawer ? this.cartDrawer.querySelector("cart-drawer-items") : null, this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle(event) {
    if (event.target.nodeName.toLowerCase() === "select" || event.target.nodeName.toLowerCase() === "option") return;
    this.dataset.selected === "true" ? (this.dataset.selected = "false", this.removeFromCart()) : (this.dataset.selected = "true", this.addToCart());
  }
  addRemoveFromCart() {
    this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty") ? this.addToCart() : this.removeFromCart();
  }
  addToCart() {
    const cartItemProduct = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (cartItemProduct) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach(variantSelectElement => {
      variantSelectElement.setAttribute("disabled", "");
    }), this.productForm.handleSubmit();
  }
  removeFromCart() {
    const cartItemProduct = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!cartItemProduct || !this.cartItems) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach(variantSelectElement => {
      variantSelectElement.setAttribute("disabled", "");
    }), this.cartItems.updateQuantity(cartItemProduct.dataset.index, 0);
  }
  updateId(id) {
    this.dataset.id = id, this.idInput.value = id;
    if (this.classicAddButton) return;
    if (this.dataset.selected === "true") {
      this.selectTimeout && clearTimeout(this.selectTimeout);
      this.removeFromCart();
      const onCartQuantityUpdated = event => {
        event.detail.handle === "handle" && (this.addToCart(), document.removeEventListener("cartQuantityUpdated", onCartQuantityUpdated));
      };
      document.addEventListener("cartQuantityUpdated", onCartQuantityUpdated);
    }
  }
  getUpdateRequired() {
    const cartItemProduct = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let updateRequired = false;
    if (cartItemProduct && this.dataset.selected === "false") updateRequired = true;
    else !cartItemProduct && this.dataset.selected === "true" && (updateRequired = true);
    return updateRequired;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);

function displayPrices(price, comparePrice, sectionId, comparePriceEl, moneyFormat) {
  if (!moneyFormat) return;
  if (price && sectionId) {
    var formattedPrice = formatMoney(price, moneyFormat);
    sectionId.innerHTML = formattedPrice;
  }
  if (comparePrice && comparePriceEl) {
    var formattedPrice = formatMoney(comparePrice, moneyFormat);
    comparePriceEl.innerHTML = formattedPrice, comparePrice > price ? comparePriceEl.classList.remove("hidden") : comparePriceEl.classList.add("hidden");
  }
}

function initTrapFocus() {
  isIe = false;
  if (document.querySelector("footer") && document.querySelector("footer").dataset.type === null) returnfalse;
  returntrue;
}

function formatMoney(cents, format, trimZeroCents = false) {
  typeof cents == "string" && (cents = cents.replace(".", ""));
  var formatted = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format;

  function defaultOption(value, fallback) {
    return typeof value == "undefined" ? fallback : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2), thousands = defaultOption(thousands, ","), decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) return 0;
    number = (number / 100).toFixed(precision);
    var parts = number.split("."),
      replace = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      centsPart = parts[1] ? decimal + parts[1] : "";
    return trimZeroCents && centsPart === decimal + "00" && (centsPart = ""), replace + centsPart;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      formatted = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      formatted = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      formatted = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      formatted = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_space_separator":
      formatted = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      formatted = formatWithDelimiters(cents, 0, " ", ",");
      break;
    case "amount_with_apostrophe_separator":
      formatted = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      formatted = formatWithDelimiters(cents, 0, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, formatted);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super(), this.saveLocalStorage = this.dataset.saveLocalStorage === "true";
    if (this.saveLocalStorage) this.storeLocalStorageData();
  }
  storeLocalStorageData() {
    if (!this.dataset.handle || !this.dataset.id || !this.dataset.mainProduct || !this.dataset.requirement || !this.dataset.type) return;
    updateGiftGoalInStorage({
      "giftHandle": this.dataset.handle,
      "giftVariantId": this.dataset.id,
      "unlockType": this.dataset.type,
      "unlockRequirement": Number(this.dataset.requirement),
      "unlockTarget": this.dataset.mainProduct
    });
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);

function initToggleUpsells() {
  const cartDrawer = document.querySelector("cart-drawer");
  cartDrawer && cartDrawer.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(upsellEl => {
    if (upsellEl.addRemoveFromCart) upsellEl.addRemoveFromCart();
  });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super(), this.offerItems = this.querySelectorAll(".main-offer-item"), this.updatePrices = this.dataset.updatePrices === "true", this.updatePrices && (this.priceSpan = this.querySelector(".bundle-deals__total-price-js"), this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js"), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat);
  }
  updateTotalPrices() {
    if (!this.updatePrices) return;
    var totalPrice = 0,
      totalComparePrice = 0;
    for (let giftsToMonitorVar = 0; giftsToMonitorVar < this.offerItems.length; giftsToMonitorVar++) {
      totalPrice += parseInt(this.offerItems[giftsToMonitorVar].price), totalComparePrice += parseInt(this.offerItems[giftsToMonitorVar].comparePrice);
    }
    totalPrice = totalPrice * this.percentageLeft - this.fixedDiscount, displayPrices(totalPrice, totalComparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name, this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea"), this.inputRadios = this.querySelectorAll("[type=\"radio\"]"), this.select = this.querySelector(".select__select"), this.productForm = document.getElementById("product-form-" + this.dataset.section), this.prevValue = this.dataset.defaultValue, this.isRequired = this.dataset.required === "true", this.isText = true, this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") this.isText = false;
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true, this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc"), this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section), this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label"), this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error"), this.atcErrorMsg = this.dataset.atcErrorMsg, this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      if (this.mainAtcBtnError) this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true", this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label"), this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        if (this.stickyAtcBtnError) this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) this.input.addEventListener("input", this.handleChange.bind(this));
    this.inputRadios.forEach(inputRadio => {
      inputRadio.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(event) {
    const fieldValue = event.target.value.trim();
    if (event.target.checkValidity()) this.prevValue = fieldValue;
    else {
      event.target.value = this.prevValue;
      return;
    }
    this.dataset.value = fieldValue, this.productFormInput.value = fieldValue;
    if (this.isRequired && this.isText) this.validateValue(fieldValue, event.target);
  }
  validateValue(value, inputEl) {
    const isValid = value.length > 0 ? true : false;
    if (isValid === this.isValid) return;
    this.isValid = isValid;
    inputEl && (this.isValid ? (inputEl.classList.remove("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1) : (inputEl.classList.add("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1));
    const mainAtcButton = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      mainAtcButton2 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(atcButton => {
      mainAtcButton && !mainAtcButton2 ? atcButton.removeAttribute("disabled") : atcButton.setAttribute("disabled", "");
    });
    if (this.atcErrorMsg.length === 0) return;
    mainAtcButton ? (this.mainAtcBtnLabel.style.display = "", this.mainAtcBtnError.style.display = "none", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = "", this.stickyAtcBtnError.style.display = "none")) : (this.mainAtcBtnLabel.style.display = "none", this.mainAtcBtnError.style.display = "", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = "none", this.stickyAtcBtnError.style.display = ""));
  }
  createInputs() {
    this.productFormInput = document.createElement("input"), this.productFormInput.setAttribute("type", "hidden"), this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]"), this.productFormInput.value = this.dataset.defaultValue, this.productFormInput.classList.add("spx-property-input"), this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);

function playMedia() {
  if (!serial) serial = document.currentScript.dataset.animationsType || "";
}
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.secondarySelectSelector = "StickyAtcVariantPicker-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = false, this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true", this.prependMedia = this.dataset.disablePrepend != "true", this.filtering = this.dataset.hasFiltering === "true", this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.hasQuantityBreaksPicker && (this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle, this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(true, "", false), this.updatePickupAvailability(), this.removeErrorMessage(), this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) return;
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) return;
      }
      this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl();
    }
  }
  updateOptions() {
    const selectedOptions = [];
    this.querySelectorAll(".product-form__input").forEach(optionInput => {
      let selectedValue;
      const productFormInputType = optionInput.querySelector(".product-form__input__type").dataset.type;
      productFormInputType == "dropdown" || productFormInputType == "dropdwon" ? selectedValue = optionInput.querySelector(".select__select").value : selectedValue = optionInput.querySelector("input[type=\"radio\"]:checked").value, selectedOptions.push(selectedValue);
    }), this.options = selectedOptions;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options.map((optionValue, optionIndex) => {
        return this.options[optionIndex] === optionValue;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const idList = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    idList.forEach(id => id.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    const productModal = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!productModal) return;
    const dataMediaId = productModal.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    productModal.prepend(dataMediaId);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const share = document.getElementById("Share-" + this.dataset.section);
    if (!share || !share.updateUrl) return;
    share.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const productFormList = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    productFormList.forEach(productForm => {
      const inputName = productForm.querySelector("input[name=\"id\"]");
      inputName.value = this.currentVariant.id, inputName.dispatchEvent(new Event("change", {
        "bubbles": true
      }));
    });
  }
  updateVariantStatuses() {
    const matchingVariants = this.variantData.filter(variant => this.querySelector(":checked").value === variant.option1);
    let optionInputs;
    this.isSecondary && this.secondarySelect ? optionInputs = [...this.secondarySelect.querySelectorAll(".product-form__input")] : optionInputs = [...this.querySelectorAll(".product-form__input")], optionInputs.forEach((optionInput, optionIndex) => {
      if (optionIndex === 0) return;
      const inputTypeList = [...optionInput.querySelectorAll("input[type=\"radio\"], .select__select option")],
        previousValue = optionInputs[optionIndex - 1].querySelector(":checked").value,
        availableValues = matchingVariants.filter(variant2 => variant2.available && variant2["option" + optionIndex] === previousValue).map(variant3 => variant3["option" + (optionIndex + 1)]),
        existingValues = matchingVariants.filter(variant4 => variant4["option" + optionIndex] === previousValue).map(variant5 => variant5["option" + (optionIndex + 1)]);
      this.setInputAvailability(inputTypeList, availableValues, existingValues, this.skipNonExistent, this.skipUnavailable);
    });
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions, existingValues, skipNonExistent = false, skipUnavailable = false) {
    listOfOptions.forEach(listOfOption => {
      listOfOption.classList.remove("unavailable", "non-existent", "disabled"), listOfOption.removeAttribute("disabled"), listOfOption.removeAttribute("hidden");
      const optionValue = listOfOption.getAttribute("value");
      let swatch = null;
      listOfOption.dataset.swatch === "true" && (swatch = listOfOption.closest(".color-swatch"));
      if (swatch) swatch.classList.remove("unavailable", "non-existent", "disabled");
      if (existingValues.includes(optionValue)) {
        if (listOfAvailableOptions.includes(optionValue)) {
          if (listOfOption.nodeName === "OPTION") listOfOption.innerText = optionValue;
          else {
            listOfOption.classList.remove("disabled");
            if (swatch) swatch.classList.remove("disabled");
          }
        } else {
          if (listOfOption.nodeName === "OPTION") listOfOption.innerText = window.variantStrings.unavailable_with_option.replace("[value]", optionValue), listOfOption.classList.add("unavailable"), skipUnavailable && (listOfOption.setAttribute("disabled", ""), listOfOption.setAttribute("hidden", ""));
          else {
            listOfOption.classList.add("disabled", "unavailable");
            if (swatch) swatch.classList.add("disabled", "unavailable");
          }
        }
      } else {
        if (listOfOption.nodeName === "OPTION") listOfOption.innerText = window.variantStrings.unavailable_with_option.replace("[value]", optionValue), listOfOption.classList.add("non-existent"), skipNonExistent && (listOfOption.setAttribute("disabled", ""), listOfOption.setAttribute("hidden", ""));
        else {
          listOfOption.classList.add("disabled", "non-existent");
          if (swatch) swatch.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const pickupAvailability = document.querySelector("pickup-availability");
    if (!pickupAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (pickupAvailability.fetchAvailability) pickupAvailability.fetchAvailability(this.currentVariant.id);
    } else pickupAvailability.removeAttribute("available"), pickupAvailability.innerHTML = "";
  }
  removeErrorMessage() {
    const sectionEl = this.closest("section");
    if (!sectionEl) return;
    const productForm = sectionEl.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const currentVariant = this.currentVariant.id,
      dataset = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + currentVariant + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(response => response.text()).then(response2 => {
      if (this.currentVariant.id !== currentVariant) return;
      const parsedDoc = new DOMParser().parseFromString(response2, "text/html"),
        price = document.getElementById("price-" + this.dataset.section),
        price2 = parsedDoc.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        stickyAtcSeparatePrice = document.getElementById("sticky-atc-separate-price-" + this.dataset.section),
        stickyAtcSeparatePrice2 = parsedDoc.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        stickyAtcPrice = document.getElementById("sticky-atc-price-" + this.dataset.section),
        stickyAtcPrice2 = parsedDoc.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        stickyAtcImage = document.getElementById("sticky-atc-image-" + this.dataset.section);
      if (stickyAtcImage && this.currentVariant.featured_image) stickyAtcImage.src = this.currentVariant.featured_image.src;
      const mainAtcPrice = document.getElementById("main-atc-price-" + this.dataset.section),
        mainAtcPrice2 = parsedDoc.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        idList = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]"),
        idList2 = parsedDoc.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]"),
        sku = parsedDoc.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        sku2 = document.getElementById("Sku-" + this.dataset.section),
        inventory = parsedDoc.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        inventory2 = document.getElementById("Inventory-" + this.dataset.section);
      if (price && price2) price.innerHTML = price2.innerHTML;
      if (stickyAtcSeparatePrice && stickyAtcSeparatePrice2) stickyAtcSeparatePrice.innerHTML = stickyAtcSeparatePrice2.innerHTML;
      if (stickyAtcPrice && stickyAtcPrice2) stickyAtcPrice.innerHTML = stickyAtcPrice2.innerHTML;
      if (mainAtcPrice2 && mainAtcPrice) mainAtcPrice.innerHTML = mainAtcPrice2.innerHTML;
      if (idList && idList2)
        for (var giftsToMonitorVar = 0; giftsToMonitorVar < idList.length; giftsToMonitorVar++) {
          idList[giftsToMonitorVar].innerHTML = idList2[giftsToMonitorVar].innerHTML;
        }
      if (inventory && inventory2) inventory2.innerHTML = inventory.innerHTML;
      sku && sku2 && (sku2.innerHTML = sku.innerHTML, sku2.classList.toggle("visibility-hidden", sku.classList.contains("visibility-hidden")));
      if (this.QuantityBreaks) {
        const quantityBreaks = parsedDoc.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          dynamicPriceList = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
          dynamicPriceList2 = quantityBreaks.querySelectorAll(".dynamic-price");
        for (let giftsToMonitorVar = 0; giftsToMonitorVar < dynamicPriceList.length; giftsToMonitorVar++) {
          dynamicPriceList[giftsToMonitorVar].innerHTML = dynamicPriceList2[giftsToMonitorVar].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(variantSelect => {
            variantSelect.dataset.selectedId = this.currentVariant.id;
          });
          const quantityBreakVariantSelectList = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select"),
            quantityBreakVariantSelectList2 = quantityBreaks.querySelectorAll(".quantity-break__variant-select");
          for (let giftsToMonitorVar = 0; giftsToMonitorVar < quantityBreakVariantSelectList.length; giftsToMonitorVar++) {
            quantityBreakVariantSelectList[giftsToMonitorVar].innerHTML = quantityBreakVariantSelectList2[giftsToMonitorVar].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        };
        this.currentVariant.featured_image && this.QuantityBreaks.querySelectorAll(".quantity-break__selector-item__image img").forEach(image => {
          image.src = this.currentVariant.featured_image.src;
        }), this.QuantityBreaks.updatePdpPrices && (this.QuantityBreaks.dataset.basePrice = quantityBreaks.dataset.basePrice, this.QuantityBreaks.labels.forEach(label => {
          label.dataset.baseComparePrice = quantityBreaks.querySelector("label[data-input=\"" + label.dataset.input + "\"]").dataset.baseComparePrice;
        }), this.QuantityBreaks.initOfferPrices(true), this.QuantityBreaks.updateInnerPrices());
      }
      const subscriptionWidget = document.getElementById("SubscriptionWidget-" + this.dataset.section),
        subscriptionWidget2 = parsedDoc.getElementById("SubscriptionWidget-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      if (subscriptionWidget) {
        if (!subscriptionWidget2) subscriptionWidget.classList.add("hidden");
        else {
          subscriptionWidget.dataset.basePrice = subscriptionWidget2.dataset.basePrice || "", subscriptionWidget.dataset.baseComparePrice = subscriptionWidget2.dataset.baseComparePrice || "";
          const planChanged = (subscriptionWidget.dataset.firstSellingPlanId || "") !== (subscriptionWidget2.dataset.firstSellingPlanId || "");
          if (planChanged && typeof subscriptionWidget.hydrateFromExternalHTML === "function") subscriptionWidget.hydrateFromExternalHTML(subscriptionWidget2);
          else {
            const oneTimePriceUpdateList = subscriptionWidget.querySelectorAll(".one-time-price-update"),
              oneTimePriceUpdateList2 = subscriptionWidget2.querySelectorAll(".one-time-price-update");
            for (let giftsToMonitorVar = 0; giftsToMonitorVar < oneTimePriceUpdateList.length; giftsToMonitorVar++) {
              oneTimePriceUpdateList[giftsToMonitorVar].innerHTML = oneTimePriceUpdateList2[giftsToMonitorVar].innerHTML;
            }
            if (subscriptionWidget.updatePrices) subscriptionWidget.updateAllPrices();
          }
        }
      }
      if (this.hasQuantityBreaksPicker) {
        const variantSelects = parsedDoc.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          dynamicPriceList = this.querySelectorAll(".dynamic-price"),
          dynamicPriceList2 = variantSelects.querySelectorAll(".dynamic-price");
        for (let giftsToMonitorVar = 0; giftsToMonitorVar < dynamicPriceList.length; giftsToMonitorVar++) {
          dynamicPriceList[giftsToMonitorVar].innerHTML = dynamicPriceList2[giftsToMonitorVar].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const quantityBreakImageImgList = this.querySelectorAll(".quantity-break__image img"),
            quantityBreakImageImgList2 = variantSelects.querySelectorAll(".quantity-break__image img");
          for (let giftsToMonitorVar = 0; giftsToMonitorVar < quantityBreakImageImgList.length; giftsToMonitorVar++) {
            quantityBreakImageImgList[giftsToMonitorVar].src = quantityBreakImageImgList2[giftsToMonitorVar].src;
          }
        }
        const quantityBreakDataBasePriceList = variantSelects.querySelectorAll(".quantity-break[data-base-price]"),
          quantityBreakList = this.querySelectorAll(".quantity-break");
        for (let giftsToMonitorVar = 0; giftsToMonitorVar < quantityBreakList.length && giftsToMonitorVar < quantityBreakDataBasePriceList.length; giftsToMonitorVar++) {
          quantityBreakDataBasePriceList[giftsToMonitorVar].dataset.basePrice && (quantityBreakList[giftsToMonitorVar].dataset.basePrice = quantityBreakDataBasePriceList[giftsToMonitorVar].dataset.basePrice, quantityBreakList[giftsToMonitorVar].dataset.baseComparePrice = quantityBreakDataBasePriceList[giftsToMonitorVar].dataset.baseComparePrice);
        }
        const subscriptionWidget3 = document.getElementById("SubscriptionWidget-" + this.dataset.section);
        subscriptionWidget3 && subscriptionWidget3.isSubSelected && this.updateQuantityBreaksPickerPrices && this.updateQuantityBreaksPickerPrices(subscriptionWidget3.discountType, subscriptionWidget3.discountValue, subscriptionWidget3.moneyFormat);
      }
      if (this.secondarySelect) {
        const secondarySource = parsedDoc.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (secondarySource) this.secondarySelect.innerHTML = secondarySource.innerHTML;
      }
      const price3 = document.getElementById("price-" + this.dataset.section);
      if (price3) price3.classList.remove("visibility-hidden");
      this.dataset.options = this.currentVariant.options.join(",");
      if (inventory2) inventory2.classList.toggle("visibility-hidden", inventory.innerText === "");
      const productSubmitButton = parsedDoc.getElementById("ProductSubmitButton-" + dataset);
      this.toggleAddButton(productSubmitButton ? productSubmitButton.hasAttribute("disabled") : true, window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
        "data": {
          "sectionId": dataset,
          "html": parsedDoc,
          "variant": this.currentVariant
        }
      });
    });
  }
  toggleAddButton(disable = true, label, modifyClass = true) {
    const productForm = document.getElementById("product-form-" + this.dataset.section);
    if (!productForm) return;
    const name = productForm.querySelector("[name=\"add\"]");
    if (!name) return;
    const mainProductAtcList = document.querySelectorAll(".main-product-atc");
    var mainAtcLabelText = productForm.querySelector(".main-atc__label__text");
    if (!mainAtcLabelText) mainAtcLabelText = productForm.querySelector(".main-atc__label");
    const mainAtcPrice = productForm.querySelector(".main-atc-price"),
      stickyAtcAddButton = document.querySelector(".sticky-atc__add_button");
    let stickyLabel = null,
      stickyPrice = null;
    stickyAtcAddButton && (stickyLabel = stickyAtcAddButton.querySelector(".sticky-atc__label__text"), stickyPrice = stickyAtcAddButton.querySelector(".sticky-atc__button-price"));
    if (disable) {
      name.setAttribute("disabled", "disabled"), name.setAttribute("data-unavailable", "true");
      if (label && mainAtcLabelText) mainAtcLabelText.textContent = label;
      if (label && stickyLabel && stickyAtcAddButton.dataset.label) stickyLabel.textContent = label;
      mainProductAtcList.forEach(mainProductAtc => {
        mainProductAtc.setAttribute("disabled", "disabled");
      });
      if (mainAtcPrice) mainAtcPrice.classList.add("hidden");
      if (stickyPrice) stickyPrice.classList.add("hidden");
    } else {
      name.setAttribute("data-unavailable", "false");
      const customLabel = name.dataset.customLabel ?? window.variantStrings.addToCart;
      if (mainAtcLabelText) mainAtcLabelText.textContent = customLabel;
      if (mainAtcPrice) mainAtcPrice.classList.remove("hidden");
      if (stickyLabel && stickyAtcAddButton.dataset.label) stickyLabel.textContent = stickyAtcAddButton.dataset.label;
      if (stickyPrice) stickyPrice.classList.remove("hidden");
      name.dataset.requiredFields === name.dataset.validFields && (name.removeAttribute("disabled"), mainProductAtcList.forEach(mainProductAtc => {
        mainProductAtc.removeAttribute("disabled");
      }));
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const productForm = document.getElementById("product-form-" + this.dataset.section);
    if (!productForm) return;
    const name = productForm.querySelector("[name=\"add\"]");
    var mainAtcLabelText = productForm.querySelector(".main-atc__label__text");
    if (!mainAtcLabelText) mainAtcLabelText = productForm.querySelector(".main-atc__label");
    const price = document.getElementById("price-" + this.dataset.section),
      inventory = document.getElementById("Inventory-" + this.dataset.section),
      sku = document.getElementById("Sku-" + this.dataset.section);
    if (!name) return;
    if (mainAtcLabelText) mainAtcLabelText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent), this.variantData;
  }
  updateQuantityBreaksPickerPrices(variant, discountValue, moneyFormat) {
    if (!this.hasQuantityBreaksPicker) return;
    const quantityBreakList = this.querySelectorAll(".quantity-break");
    if (!quantityBreakList.length) return;
    quantityBreakList.forEach(quantityBreak => {
      if (!quantityBreak.dataset.basePrice) return;
      const price = parseInt(quantityBreak.dataset.basePrice),
        price2 = parseInt(quantityBreak.dataset.baseComparePrice) || price;
      let discountedPrice = price;
      if (variant && discountValue) {
        if (variant === "fixed_amount") discountedPrice = Math.max(0, price - discountValue);
        else {
          if (variant === "percentage") discountedPrice = Math.round(price * (100 - discountValue) / 100);
          else variant === "price" && (discountedPrice = discountValue);
        }
      }
      const amountSaved = price2 - discountedPrice,
        amountSavedRounded = Math.round(amountSaved / 100) * 100,
        round = price2 > 0 ? Math.round(amountSaved / price2 * 100) : 0,
        formattedPrice = formatMoney(discountedPrice, moneyFormat, true),
        formattedPrice2 = formatMoney(price2, moneyFormat, true),
        formattedPrice3 = formatMoney(amountSaved, moneyFormat, true),
        formattedPrice4 = formatMoney(amountSavedRounded, moneyFormat, true),
        variantPriceUpdateDataTextList = quantityBreak.querySelectorAll(".variant-price-update[data-text]");
      variantPriceUpdateDataTextList.forEach(variantPriceUpdateDataText => {
        let labelText = variantPriceUpdateDataText.dataset.text;
        labelText = labelText.replace("[price]", formattedPrice), labelText = labelText.replace("[compare_price]", formattedPrice2), labelText = labelText.replace("[amount_saved]", formattedPrice3), labelText = labelText.replace("[amount_saved_rounded]", formattedPrice4), labelText = labelText.replace("[percentage_saved]", round + "%"), variantPriceUpdateDataText.innerHTML = labelText;
      });
      const quantityBreakComparePrice = quantityBreak.querySelector(".quantity-break__compare-price");
      quantityBreakComparePrice && (price2 > discountedPrice ? quantityBreakComparePrice.classList.remove("hidden") : quantityBreakComparePrice.classList.add("hidden"));
    });
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super(), this.secondarySelectSelector = "variant-selects-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super(), this.secondarySelectSelector = "variant-selects-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super(), this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  onVariantChange() {
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(true, "", false), this.updateVariantStatuses(), !this.currentVariant ? (this.toggleAddButton(true, "", true), this.setUnavailable()) : (this.updateMedia(), this.updateVariantInput(), this.updateQuickAddUrl(), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut));
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const elementById = document.getElementById(this.dataset.section + "-image");
    if (!elementById) return;
    const currentVariant = this.currentVariant.featured_media.preview_image,
      src = currentVariant.src.split("?")[0],
      srcsetWidths = [165, 360, 533, 720, 940, 1066],
      srcset = srcsetWidths.filter(width => currentVariant.width >= width).map(width2 => src + "?width=" + width2 + " " + width2 + "w").join(", ");
    elementById.srcset = srcset + ", " + src + " " + currentVariant.width + "w", elementById.src = src + "?width=533";
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) return;
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);